{
  "account.account": "Profiel en beveiliging",
  "account.accountDeleted": "Uw account is succesvol verwijderd.",
  "account.accountDescription": "Naam, wachtwoord, account verwijderen",
  "account.accountSection": "Account",
  "account.changeEmail": "E-mail wijzigen",
  "account.changePassword": "Wijzig wachtwoord",
  "account.currentPassword": "Huidig wachtwoord",
  "account.dangerZone": "Risicozone",
  "account.deleteAccount": "Verwijder uw account",
  "account.deleteAccountConfirmation": "Weet u zeker dat u het account wilt verwijderen? Deze actie is onherstelbaar.",
  "account.deleteAccountDescription": "Met deze actie worden uw account en al uw gegevens verwijderd. Er is geen weg meer terug.",
  "account.emailChange": "E-mailadres wijzigen",
  "account.emailChangeConfirmation": "Bevestiging e-mailwijziging",
  "account.emailChangeFailure": "De link voor e-mailwijziging is ongeldig of verlopen.",
  "account.emailChangeIntro": "Voer uw nieuwe e-mailadres en uw huidige wachtwoord in. We sturen een link naar het nieuwe adres: uw e-mailadres wijzigt pas wanneer u die opent.",
  "account.emailChangeSuccess": "Uw e-mailadres is succesvol gewijzigd naar {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Uw e-mailadres is gewijzigd.",
  "account.emailChangeVerificationSent": "Er is een verificatie-e-mail verzonden naar uw nieuwe e-mailadres. Controleer uw inbox en klik op de link om de wijziging te bevestigen.",
  "account.manageAccount": "Accountbeheer",
  "account.newEmailAddress": "Nieuw e-mailadres",
  "account.newPassword": "Nieuw wachtwoord",
  "account.newPasswordAgain": "Nieuw wachtwoord nogmaals",
  "account.oldPassword": "Oud wachtwoord",
  "account.passwordChange": "Wachtwoord wijzigen",
  "account.passwordChangeDescription": "Houd uw account veilig",
  "account.passwordUpdated": "Wachtwoord succesvol gewijzigd.",
  "account.profile": "Profiel",
  "account.profileUpdated": "Profiel succesvol gewijzigd.",
  "account.signedInAs": "Ingelogd als",
  "account.updateYourProfile": "Werk uw profiel bij",
  "account.updateYourProfileDescription": "Naam en weergavevoorkeuren",
  "addons.accountOnHold": "Uw accountverbinding is verlopen. Maak opnieuw verbinding om de gegevensupdates te hervatten.",
  "addons.accountOnHoldTitle": "Account gepauzeerd",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Maak en haal uw API-sleutel op via deze link",
  "addons.ambientWeatherDescription": "Ambient Weather weerstations (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API-sleutel",
  "addons.applicationKey": "Applicatiesleutel",
  "addons.availableServices": "Beschikbaar",
  "addons.cannotDisconnectLastAccount": "Kan uw enige inlogmethode niet loskoppelen. Voeg eerst een andere inlogmethode toe.",
  "addons.connect": "Verbinden",
  "addons.connected": "Verbonden",
  "addons.connectedAccounts": "Gekoppelde accounts",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedServices": "Verbonden",
  "addons.connectedSince": "Verbonden sinds {date}",
  "addons.connectionSection": "Verbinding",
  "addons.connectionSuccess": "{provider}-account succesvol verbonden",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "V2 API-sleutel",
  "addons.davisDescription": "Davis Weerstations (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Haal uw V2 API-sleutels op via deze link",
  "addons.disconnect": "Loskoppelen",
  "addons.disconnectConfirmation": "Weet u zeker dat u uw {provider}-account wilt loskoppelen?",
  "addons.disconnectionSuccess": "{provider}-account succesvol losgekoppeld",
  "addons.disconnectProviderDescription": "Stopt de synchronisatie. Je geschiedenis blijft bewaard.",
  "addons.ecowittCreateAndRetrieveKeys": "Maak en haal zowel een API-sleutel als een applicatiesleutel op via deze link",
  "addons.ecowittDescription": "Ecowitt biedt professionele wifi-weerstations, draadloze binnen-buitenthermometers, vochtigheidsmeters, zeer nauwkeurige regenmeters, luchtkwaliteitsmeters en meer.",
  "addons.helpLink": "Hoe verbindt u {provider}",
  "addons.integrationsSection": "Integraties",
  "addons.myAcuriteAccountOnHold": "Uw account is in de wacht gezet. Voer uw wachtwoord in om uw account opnieuw te verbinden",
  "addons.myAcuriteDescription": "AcuRite is het nummer 1 weerstationmerk in Noord-Amerika. Als leider op het gebied van tijd-, temperatuur- en weertechnologie biedt AcuRite u gedetailleerde informatie over uw binnen- en buitenomgeving, zodat u uw dag met vertrouwen kunt plannen.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Gebruik uw Netatmo Thermostaat om de temperatuur in huis te veranderen, vanuit bed of vanaf de andere kant van de wereld.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Uw persoonlijke weerstation thuis",
  "addons.notConnected": "Niet verbonden",
  "addons.or": "of",
  "addons.providerAccountDisconnected": "De verbinding met uw weerdienst is verlopen. Maak opnieuw verbinding om de gegevensupdates te hervatten.",
  "addons.reconnect": "Opnieuw verbinden",
  "addons.socialConnectionsIntro": "Koppel uw sociale accounts voor snelle aanmelding. U kunt op elk moment accounts verbinden of loskoppelen.",
  "addons.weatherflowCreateToken": "Maak en haal uw token op via deze link",
  "addons.weatherflowTempestDescription": "Tempest Weather System met ingebouwde Wind- en Regenmeter",
  "addons.weatherServices": "Weerdiensten",
  "addons.weatherServicesConnected": "{count, plural, =0 {Geen diensten verbonden} one {# dienst verbonden} other {# diensten verbonden}}",
  "addons.weatherServicesDescription": "Verbind Netatmo, Davis, Weatherflow en meer",
  "addons.wundergroundApiKey": "API-sleutel",
  "addons.wundergroundDescription": "Weather Underground is een wereldwijde gemeenschap van mensen die gegevens van omgevingssensoren zoals weerstations en luchtkwaliteitsmonitors met elkaar verbinden, zodat we de uitgebreide, hyperlokale gegevens kunnen leveren die u nodig hebt om uw passies te stimuleren",
  "addons.wundergroundRetrieveApiKey": "Haal uw API-sleutel op via deze link",
  "addons.wundergroundStationId": "Stations-ID",
  "airQuality.adviceActivityGood": "Een ideale dag om buiten actief te zijn",
  "airQuality.adviceActivityHazardous": "Vermijd alle lichamelijke inspanning buiten",
  "airQuality.adviceActivityLabel": "Lichaamsbeweging",
  "airQuality.adviceActivityModerate": "Een goede dag om buiten actief te zijn",
  "airQuality.adviceActivitySensitive": "Overweeg kortere en minder intensieve activiteiten buiten",
  "airQuality.adviceActivityUnhealthy": "Beperk lange of intensieve activiteiten en neem vaker pauze",
  "airQuality.adviceActivityVeryUnhealthy": "Vermijd lange of intensieve activiteiten; overweeg ze naar binnen te verplaatsen",
  "airQuality.adviceGroupsGood": "Geen bijzondere voorzorgsmaatregelen nodig",
  "airQuality.adviceGroupsHazardous": "Blijf binnen en houd de inspanning laag",
  "airQuality.adviceGroupsLabel": "Gevoelige groepen",
  "airQuality.adviceGroupsModerate": "Bijzonder gevoelige personen: kortere en minder intensieve activiteiten",
  "airQuality.adviceGroupsSensitive": "Maak activiteiten buiten korter en minder intensief en neem vaker pauze",
  "airQuality.adviceGroupsUnhealthy": "Vermijd lange of intensieve activiteiten buiten; overweeg ze naar binnen te verplaatsen",
  "airQuality.adviceGroupsVeryUnhealthy": "Vermijd alle lichamelijke inspanning buiten; stel activiteiten uit of doe ze binnen",
  "airQuality.adviceTimingLabel": "Wanneer naar buiten",
  "airQuality.adviceTimingMorning": "Bij voorkeur 's ochtends: dan is het ozongehalte lager",
  "airQuality.airQuality": "Luchtkwaliteit",
  "airQuality.airQualityIndex": "Luchtkwaliteitsindex",
  "airQuality.aqiForecast": "Luchtkwaliteitsvoorspelling",
  "airQuality.co2Fresh": "Fris",
  "airQuality.co2GettingStale": "Enigszins bedompt",
  "airQuality.co2Stale": "Bedompt",
  "airQuality.dailyForecast": "Dagelijkse voorspelling",
  "airQuality.dominantPollutant": "Dominante verontreinigende stof",
  "airQuality.expectedPeak": "Verwachte piek",
  "airQuality.good": "Goed",
  "airQuality.goodDescription": "De luchtkwaliteit is redelijk tot goed en luchtverontreiniging vormt weinig of geen risico",
  "airQuality.hazardous": "Gevaarlijk voor de gezondheid",
  "airQuality.hazardousDescription": "Gezondheidswaarschuwing: iedereen kan ernstige(re) gezondheidseffecten ervaren",
  "airQuality.indoorAirQuality": "Luchtkwaliteit binnen",
  "airQuality.moderate": "Gemiddeld",
  "airQuality.moderateDescription": "Luchtkwaliteit is acceptabel; voor sommige verontreinigende stoffen kan er echter een matig gezondheidsrisico zijn voor een zeer klein aantal mensen die bijzonder gevoelig zijn voor luchtverontreiniging.",
  "airQuality.noForecastForLocation": "Er is geen luchtkwaliteitsverwachting beschikbaar voor deze locatie.",
  "airQuality.now": "Nu",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Verontreinigende stoffen",
  "airQuality.recommendations": "Aanbevelingen",
  "airQuality.sensitiveUnhealthy": "Ongezond voor gevoelige groepen",
  "airQuality.sensitiveUnhealthyDescription": "Mensen van gevoelige groepen kunnen gezondheidseffecten ervaren. Het merendeel zal waarschijnlijk niet worden getroffen.",
  "airQuality.subIndex": "AQI-subindex",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "De index begrijpen",
  "airQuality.unhealthy": "Ongezond",
  "airQuality.unhealthyDescription": "Iedereen kan gezondheidseffecten beginnen te ervaren; Mensen van gevoelige groepen kunnen meer ernstige gevolgen voor de gezondheid ervaren",
  "airQuality.veryUnhealthy": "Zeer ongezond",
  "airQuality.veryUnhealthyDescription": "Gezondheidswaarschuwingen voor noodsituaties. De kans is groter dat de hele bevolking wordt getroffen.",
  "alerts.addAlert": "Melding toevoegen",
  "alerts.addCondition": "Voorwaarde toevoegen",
  "alerts.alertAdded": "Melding succesvol toegevoegd",
  "alerts.alertAuthorizationNotice": "Meldingen werken alleen als u SmartMixin toestaat om meldingen weer te geven",
  "alerts.alertDeleted": "Melding succesvol verwijderd",
  "alerts.alertName": "Meldingsnaam",
  "alerts.alertWhen": "Meld mij wanneer:",
  "alerts.aqiGreaterThan": "AQI hoger dan",
  "alerts.aqiGreaterThanThreshold": "AQI hoger dan {value}{unit} drempelwaarde",
  "alerts.aqiLessThan": "AQI lager dan",
  "alerts.aqiLessThanThreshold": "AQI lager dan {value}{unit} drempelwaarde",
  "alerts.atLeastOneCondition": "Voeg tenminste één voorwaarde toe",
  "alerts.co2GreaterThan": "CO2 hoger dan",
  "alerts.co2GreaterThanThreshold": "CO2 hoger dan {value}{unit} drempelwaarde",
  "alerts.co2LessThan": "CO2 lager dan",
  "alerts.co2LessThanThreshold": "CO2 lager dan {value}{unit} drempelwaarde",
  "alerts.conditions": "Voorwaarden",
  "alerts.conditionsDroppedOnStationChange": "Niet ondersteund door dit station en verwijderd: {conditions}",
  "alerts.createAlert": "Melding maken",
  "alerts.dailyPrecipitationGreaterThan": "Dagelijkse neerslag groter dan",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Dagelijkse neerslag boven de drempel van {value}{unit}",
  "alerts.deleteAlert": "Verwijder melding",
  "alerts.editAlert": "Wijzig melding",
  "alerts.editCondition": "Wijzig voorwaarde",
  "alerts.gustSpeedGreaterThan": "Windstoten hoger dan",
  "alerts.gustSpeedGreaterThanThreshold": "Windstoten hoger dan {value}{unit} drempelwaarde",
  "alerts.gustSpeedLessThan": "Windstoten lager dan",
  "alerts.gustSpeedLessThanThreshold": "Windstoten lager dan {value}{unit} drempelwaarde",
  "alerts.heatIndexGreaterThan": "Hitte-index hoger dan",
  "alerts.heatIndexGreaterThanThreshold": "Hitte-index hoger dan {value}{unit} drempelwaarde",
  "alerts.heatIndexLessThan": "Hitte-index lager dan",
  "alerts.heatIndexLessThanThreshold": "Hitte-index lager dan {value}{unit} drempelwaarde",
  "alerts.humidexGreaterThan": "Humidex hoger dan",
  "alerts.humidexGreaterThanThreshold": "Humidex hoger dan {value}{unit} drempelwaarde",
  "alerts.humidexLessThan": "Humidex lager dan",
  "alerts.humidexLessThanThreshold": "Humidex lager dan {value}{unit} drempelwaarde",
  "alerts.humidityGreaterThan": "Luchtvochtigheid hoger dan",
  "alerts.humidityGreaterThanThreshold": "Luchtvochtigheid hoger dan {value}{unit} drempelwaarde",
  "alerts.humidityLessThan": "Luchtvochtigheid lager dan",
  "alerts.humidityLessThanThreshold": "Luchtvochtigheid lager dan {value}{unit} drempelwaarde",
  "alerts.inProgress": "Bezig",
  "alerts.leafWetnessGreaterThan": "Bladvochtigheid hoger dan",
  "alerts.leafWetnessGreaterThanThreshold": "Bladvochtigheid hoger dan {value}{unit} drempelwaarde",
  "alerts.leafWetnessLessThan": "Bladvochtigheid lager dan",
  "alerts.leafWetnessLessThanThreshold": "Bladvochtigheid lager dan {value}{unit} drempelwaarde",
  "alerts.myAlerts": "Mijn meldingen",
  "alerts.noConfiguredAlert": "Er zijn nog geen meldingen, voeg er een toe",
  "alerts.noiseGreaterThan": "Geluid hoger dan",
  "alerts.noiseGreaterThanThreshold": "Geluid hoger dan {value}{unit} drempelwaarde",
  "alerts.noiseLessThan": "Geluid lager dan",
  "alerts.noiseLessThanThreshold": "Geluid lager dan {value}{unit} drempelwaarde",
  "alerts.noteOnConditions": "Houd er rekening mee dat de melding wordt geactiveerd wanneer aan alle onderstaande voorwaarden is voldaan",
  "alerts.noTriggerHistory": "Deze melding is nog niet geactiveerd.",
  "alerts.pm10GreaterThan": "PM 10 hoger dan",
  "alerts.pm10GreaterThanThreshold": "PM 10 hoger dan {value}{unit} drempelwaarde",
  "alerts.pm10LessThan": "PM 10 lager dan",
  "alerts.pm10LessThanThreshold": "PM 10 lager dan {value}{unit} drempelwaarde",
  "alerts.pm1GreaterThan": "PM 1 hoger dan",
  "alerts.pm1GreaterThanThreshold": "PM 1 hoger dan {value}{unit} drempelwaarde",
  "alerts.pm1LessThan": "PM 1 lager dan",
  "alerts.pm1LessThanThreshold": "PM 1 lager dan {value}{unit} drempelwaarde",
  "alerts.pm2p5GreaterThan": "PM 2.5 hoger dan",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 hoger dan {value}{unit} drempelwaarde",
  "alerts.pm2p5LessThan": "PM 2.5 lager dan",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 lager dan {value}{unit} drempelwaarde",
  "alerts.postStormSummary": "Samenvatting na de bui",
  "alerts.postStormSynopsisHelper": "U ontvangt een samenvattingsmelding na elke regenbui.",
  "alerts.postStormSynopsisSoleCondition": "Een samenvatting na de bui kan niet worden gecombineerd met andere voorwaarden.",
  "alerts.precipitationGreaterThan": "Uurlijkse neerslag groter dan",
  "alerts.precipitationGreaterThanThreshold": "Uurlijkse neerslag boven de drempel van {value}{unit}",
  "alerts.pressureGreaterThan": "Luchtdruk hoger dan",
  "alerts.pressureGreaterThanThreshold": "Luchtdruk hoger dan {value}{unit} drempelwaarde",
  "alerts.pressureLessThan": "Luchtdruk lager dan",
  "alerts.pressureLessThanThreshold": "Luchtdruk lager dan {value}{unit} drempelwaarde",
  "alerts.rainRateGreaterThan": "Regenintensiteit groter dan",
  "alerts.rainRateGreaterThanThreshold": "Regenintensiteit boven de drempel van {value}{unit}",
  "alerts.sensorNotReporting": "Deze sensor stuurt op dit moment geen gegevens. De melding wordt hervat zodra hij dat weer doet.",
  "alerts.soilMoistureGreaterThan": "Bodemvocht hoger dan",
  "alerts.soilMoistureGreaterThanThreshold": "Bodemvocht hoger dan {value}{unit} drempelwaarde",
  "alerts.soilMoistureLessThan": "Bodemvocht lager dan",
  "alerts.soilMoistureLessThanThreshold": "Bodemvocht lager dan {value}{unit} drempelwaarde",
  "alerts.solarRadiationGreaterThan": "Zonnestraling hoger dan",
  "alerts.solarRadiationGreaterThanThreshold": "Zonnestraling hoger dan {value}{unit} drempelwaarde",
  "alerts.solarRadiationLessThan": "Zonnestraling lager dan",
  "alerts.solarRadiationLessThanThreshold": "Zonnestraling lager dan {value}{unit} drempelwaarde",
  "alerts.stormChartUnavailable": "De regengeschiedenis voor deze bui is niet beschikbaar.",
  "alerts.stormDetail": "Samenvatting van de bui",
  "alerts.stormDuration": "Duur",
  "alerts.stormEnd": "Einde",
  "alerts.stormPeakRate": "Maximale regenintensiteit",
  "alerts.stormStart": "Begin",
  "alerts.stormTotal": "Totale neerslag",
  "alerts.temperatureGreaterThan": "Temperatuur hoger dan",
  "alerts.temperatureGreaterThanThreshold": "Temperatuur hoger dan {value}{unit} drempelwaarde",
  "alerts.temperatureLessThan": "Temperatuur lager dan",
  "alerts.temperatureLessThanThreshold": "Temperatuur lager dan {value}{unit} drempelwaarde",
  "alerts.thresholdOutOfRange": "Moet tussen {min} en {max} liggen",
  "alerts.thswGreaterThan": "THSW hoger dan",
  "alerts.thswGreaterThanThreshold": "THSW hoger dan {value}{unit} drempelwaarde",
  "alerts.thswLessThan": "THSW lager dan",
  "alerts.thswLessThanThreshold": "THSW lager dan {value}{unit} drempelwaarde",
  "alerts.thwGreaterThan": "THW hoger dan",
  "alerts.thwGreaterThanThreshold": "THW hoger dan {value}{unit} drempelwaarde",
  "alerts.thwLessThan": "THW lager dan",
  "alerts.thwLessThanThreshold": "THW lager dan {value}{unit} drempelwaarde",
  "alerts.triggerHistory": "Meldingsgeschiedenis",
  "alerts.uvGreaterThan": "UV index hoger dan",
  "alerts.uvGreaterThanThreshold": "UV index hoger dan {value}{unit} drempelwaarde",
  "alerts.uvLessThan": "UV index lager dan",
  "alerts.uvLessThanThreshold": "UV index lager dan {value}{unit} drempelwaarde",
  "alerts.visibilityGreaterThanThreshold": "Zicht meer dan {value}{unit} drempelwaarde",
  "alerts.visibilityLessThanThreshold": "Zicht minder dan {value}{unit} drempelwaarde",
  "alerts.visiblityGreaterThan": "Zicht meer dan",
  "alerts.visiblityLessThan": "Zicht minder dan",
  "alerts.whichMeasure": "Voor welke meting wilt u een melding ontvangen?",
  "alerts.whichModule": "Op welke module zou u willen worden gewaarschuwd?",
  "alerts.whichSensor": "Voor welke sensor zou u willen worden gewaarschuwd?",
  "alerts.windChillGreaterThan": "Windchill hoger dan",
  "alerts.windChillGreaterThanThreshold": "Windchill hoger dan {value}{unit} drempelwaarde",
  "alerts.windChillLessThan": "Windchill lager dan",
  "alerts.windChillLessThanThreshold": "Windchill lager dan {value}{unit} drempelwaarde",
  "alerts.windSpeedGreaterThan": "Windkracht hoger dan",
  "alerts.windSpeedGreaterThanThreshold": "Windkracht hoger dan {value}{unit} drempelwaarde",
  "alerts.windSpeedLessThan": "Windkracht lager dan",
  "alerts.windSpeedLessThanThreshold": "Windkracht lager dan {value}{unit} drempelwaarde",
  "appUpdate.updateAvailable": "Update beschikbaar",
  "appUpdate.updateAvailableOpenAppStore": "Tik om de App Store te openen",
  "appUpdate.updateAvailableOpenGooglePlay": "Tik om Google Play te openen",
  "appUpdate.updateAvailableVersion": "Update beschikbaar: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Een upgrade van de applicatie is vereist. Bezoek Google Play om te upgraden.",
  "appUpdate.upgradeRequiredIos": "Een upgrade van de applicatie is vereist. Bezoek de App Store om te upgraden.",
  "astral.aboveHorizonAllDay": "De hele dag boven de horizon",
  "astral.aboveTheHorizon": "boven de horizon",
  "astral.apparentSize": "Schijnbare diameter",
  "astral.apparentSizeAcross": "{size} in doorsnede",
  "astral.astronomicalDawn": "Astronomische dageraad",
  "astral.astronomicalDusk": "Astronomische schemering",
  "astral.belowHorizonAllDay": "De hele dag onder de horizon",
  "astral.belowHorizonSince": "Onder de horizon sinds {time}",
  "astral.belowHorizonSinceOn": "Onder de horizon sinds {day} {time}",
  "astral.brightAllNight": "De hele nacht licht — nooit volledig donker",
  "astral.brightestMoment": "Helderste moment",
  "astral.civilDawn": "Burgerlijke dageraad",
  "astral.civilDusk": "Burgerlijke schemering",
  "astral.darkSkyBetween": "Donkere hemel {from} → {to}",
  "astral.darkSkyWindow": "Donkere hemel {from} → {to} · {duration} zonder maan",
  "astral.dayLength": "Daglengte",
  "astral.daylightThroughTheYear": "Daglengte door het jaar heen",
  "astral.dayOfCycle": "dag {day} van {total}",
  "astral.doesNotOccurToday": "Vindt vandaag niet plaats",
  "astral.domeHint": "Sleep om door de nacht te gaan",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Vroegste zonsopkomst",
  "astral.earliestSunset": "Vroegste zonsondergang",
  "astral.equinox": "Equinox",
  "astral.equinoxIn": "Equinox over {days, plural, one {# dag} other {# dagen}}",
  "astral.evening": "Avond",
  "astral.exactPhaseAt": "Precies om {time}",
  "astral.firstQuarter": "Eerste kwartier",
  "astral.firstSunriseIn": "Eerste zonsopkomst over {days, plural, one {# dag} other {# dagen}}",
  "astral.firstSunsetIn": "Eerste zonsondergang over {days, plural, one {# dag} other {# dagen}}",
  "astral.fullMoon": "Volle maan",
  "astral.goldenHourBegins": "Begin gouden uur",
  "astral.goldenHourEnds": "Einde gouden uur",
  "astral.highestPoint": "Hoogste punt",
  "astral.inDays": "over {days, plural, one {# dag} other {# dagen}}",
  "astral.lastQuarter": "Laatste kwartier",
  "astral.latestSunrise": "Laatste zonsopkomst",
  "astral.latestSunset": "Laatste zonsondergang",
  "astral.litShort": "Verlicht.",
  "astral.longestDay": "Langste dag",
  "astral.lowestPoint": "Laagste punt",
  "astral.maxAltitudeShort": "Max",
  "astral.midday": "Middag",
  "astral.midnightSun": "Middernachtzon",
  "astral.midnightSunPeriod": "Middernachtzon",
  "astral.milestoneFootnotePolar": "Hier komt de zon {days, plural, one {# dag} other {# dagen}} per jaar niet op en gaat ze niet onder, dus in plaats van de gebruikelijke uitersten van zonsopkomst en zonsondergang toont de lijst wanneer dat gebeurt.",
  "astral.milestoneFootnoteTemperate": "De vroegste zonsondergang en de laatste zonsopkomst vallen niet op de kortste dag — de tijdsvereffening, niet de zonnewende, bepaalt die twee data.",
  "astral.moon": "Maan",
  "astral.moonAltitude": "Hoogte",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Afstand",
  "astral.moonlessFor": "{duration} zonder maan",
  "astral.moonPhases": "Maanfasen",
  "astral.moonrise": "Maansopkomst",
  "astral.moonset": "Maansondergang",
  "astral.moonUpAllNight": "De maan staat de hele nacht aan de hemel",
  "astral.moonWashesOutNight": "De maan staat van {rise} tot {set} aan de hemel en verlicht de hele nacht",
  "astral.morning": "Ochtend",
  "astral.nauticalDawn": "Nautische dageraad",
  "astral.nauticalDusk": "Nautische schemering",
  "astral.newMoon": "Nieuwe maan",
  "astral.nextDay": "+1 dag",
  "astral.nextProperlyDarkNight": "Volgende echt donkere nacht",
  "astral.nextRise": "volgende opkomst om {time}",
  "astral.nextRiseOn": "volgende opkomst {day} om {time}",
  "astral.nextSevenNights": "De komende zeven nachten",
  "astral.noAstronomicalDarknessTonight": "Geen astronomische duisternis vannacht",
  "astral.noDarkNightAhead": "Geen in de komende twee weken",
  "astral.noSunriseToday": "Vandaag geen zonsopkomst",
  "astral.nowAtBearing": "nu {altitude} · azimut {direction}",
  "astral.observing": "Waarnemen",
  "astral.ofDaylightLeft": "daglicht over",
  "astral.overTheNextThreeWeeks": "in de komende 3 weken",
  "astral.percentLit": "{percent} verlicht",
  "astral.polarNight": "Poolnacht",
  "astral.polarNightPeriod": "Poolnacht",
  "astral.rightNow": "Nu",
  "astral.riseShort": "Op",
  "astral.setShort": "Onder",
  "astral.shortestDay": "Kortste dag",
  "astral.solarNoon": "Ware middag",
  "astral.solstice": "Zonnewende",
  "astral.sunBelowHorizon": "Zon {degrees}° onder de horizon",
  "astral.sunEvents": "Zonnegebeurtenissen",
  "astral.sunNeverDarkEnough": "De zon komt nooit 18° onder de horizon",
  "astral.sunNeverSets": "De zon gaat niet onder",
  "astral.sunrise": "Zonsopkomst",
  "astral.sunriseAndSunset": "Zonsopkomst en -ondergang",
  "astral.sunriseAt": "Zonsopgang om {time}",
  "astral.sunset": "Zonsondergang",
  "astral.sunsetAt": "Zonsondergang om {time}",
  "astral.thisYearAtNorth": "Dit jaar op {degrees}° NB",
  "astral.thisYearAtSouth": "Dit jaar op {degrees}° ZB",
  "astral.tonight": "Vannacht",
  "astral.twilightAllNight": "De hele nacht schemering — nooit volledig donker",
  "astral.upFor": "{duration} boven de horizon",
  "astral.usableLight": "Bruikbaar licht",
  "astral.vsAverage": "{percent} t.o.v. gemiddelde",
  "astral.vsYesterday": "t.o.v. gisteren",
  "astral.waningCrescent": "Afnemende maansikkel",
  "astral.waningGibbous": "Afnemende maan",
  "astral.waxingCrescent": "Wassende maansikkel",
  "astral.waxingGibbous": "Wassende maan",
  "astral.whereToLook": "Waar te kijken",
  "astral.withoutTheMoon": "{duration} zonder maan",
  "auth.alreadyHaveAccount": "Heeft u al een account?",
  "auth.authContainerTagline": "Uw persoonlijke weerdashboard. Verbind uw stations en krijg realtime gegevens binnen handbereik.",
  "auth.backToLogin": "Terug naar inloggen",
  "auth.checkYourEmail": "Controleer uw e-mail",
  "auth.continueWithApple": "Doorgaan met Apple",
  "auth.continueWithFacebook": "Doorgaan met Facebook",
  "auth.continueWithGoogle": "Doorgaan met Google",
  "auth.email": "E-mailadres",
  "auth.emailRequiredLoginFacebook": "E-mailtoestemming is vereist.",
  "auth.emailVerification": "E-mailverificatie",
  "auth.emailVerificationFailure": "Er is een probleem opgetreden met uw e-mailverificatie.",
  "auth.emailVerificationSuccess": "Uw e-mailadres is succesvol geverifieerd.",
  "auth.firstName": "Voornaam",
  "auth.forgotPassword": "Wachtwoord vergeten?",
  "auth.forgotPasswordSubtitle": "Voer uw e-mailadres in en wij sturen u een link om uw wachtwoord te resetten.",
  "auth.lastName": "Achternaam",
  "auth.login": "Inloggen",
  "auth.loginSubtitle": "Welkom terug! Vul alstublieft uw gegevens in.",
  "auth.loginToSmartMixinDescription": "Log in bij SmartMixin om uw weerstations te openen, analyses te bekijken en uw persoonlijke weerdashboard te beheren.",
  "auth.logout": "Uitloggen",
  "auth.logoutConfirmation": "Wilt u uitloggen?",
  "auth.noAccountYet": "Heeft u nog geen account?",
  "auth.or": "of",
  "auth.password": "Wachtwoord",
  "auth.passwordReset": "Wachtwoord resetten",
  "auth.passwordResetSuccess": "Uw wachtwoord is succesvol aangepast.",
  "auth.register": "Account aanmaken",
  "auth.registerDescription": "Maak een gratis SmartMixin-account aan om uw weerstations te koppelen, weerdata te volgen en toegang te krijgen tot krachtige analysetools.",
  "auth.registerSubtitle": "Maak uw account aan om te beginnen.",
  "auth.restorePassword": "Wachtwoord herstellen",
  "auth.restorePasswordSuccess": "Een link voor het opnieuw instellen van uw wachtwoord met verdere instructies is gestuurd naar {emailAddress}.",
  "auth.sendReset": "Verstuur de herstelinstructies",
  "auth.signInWithApple": "Inloggen met Apple",
  "auth.socialAccount": "of gebruik uw account",
  "auth.staffVerificationCode": "Verificatiecode",
  "auth.staffVerificationExpiresIn": "Geverifieerd. Verloopt over {duration}.",
  "auth.staffVerificationInvalidCode": "Onjuiste code. Probeer het opnieuw.",
  "auth.staffVerificationLoginAsStopped": "Login As is gestopt: voer een verificatiecode in op het Debug-scherm om door te gaan.",
  "auth.staffVerificationNotEnrolled": "Er is geen authenticator-app ingesteld voor uw account. Voeg er een toe in de beveiligingsinstellingen van de backoffice.",
  "auth.staffVerificationPrompt": "Voer de 6-cijferige code uit uw authenticator-app of een herstelcode in om Login As en het zoeken naar gebruikers te gebruiken.",
  "auth.staffVerificationSetupLink": "Authenticator-app toevoegen",
  "auth.staffVerificationSubmit": "Verifiëren",
  "auth.staffVerificationTitle": "Verificatie voor medewerkers",
  "calendar.afternoon": "Middag",
  "calendar.april": "April",
  "calendar.august": "Augustus",
  "calendar.changePeriod": "Periode: {period}. Periode wijzigen",
  "calendar.currentDay": "Vandaag",
  "calendar.dateFormat": "Datumnotatie",
  "calendar.day": "Dag",
  "calendar.december": "December",
  "calendar.durationHours": "{hours} u",
  "calendar.durationHoursMinutes": "{hours} u {minutes} min",
  "calendar.durationMinutes": "{minutes} min",
  "calendar.durationMinutesSeconds": "{minutes} min {seconds} s",
  "calendar.durationSeconds": "{seconds} s",
  "calendar.endTime": "Eindtijd",
  "calendar.evening": "Avond",
  "calendar.february": "Februari",
  "calendar.goToNextDay": "Volgende dag",
  "calendar.goToNextMonth": "Volgende maand",
  "calendar.goToNextWeek": "Volgende week",
  "calendar.goToNextYear": "Volgend jaar",
  "calendar.goToPreviousDay": "Vorige dag",
  "calendar.goToPreviousMonth": "Vorige maand",
  "calendar.goToPreviousWeek": "Vorige week",
  "calendar.goToPreviousYear": "Vorig jaar",
  "calendar.hour": "Uur",
  "calendar.hoursCount": "{count, plural, one {# uur} other {# uur}}",
  "calendar.hoursShort": "u",
  "calendar.hoursShortCount": "{count, plural, one {# u} other {# u}}",
  "calendar.january": "Januari",
  "calendar.july": "Juli",
  "calendar.june": "Juni",
  "calendar.last12Hours": "Laatste 12 uur",
  "calendar.last24Hours": "Laatste 24 uur",
  "calendar.last30Days": "Laatste 30 dagen",
  "calendar.last3Hours": "Laatste 3 uur",
  "calendar.last6Hours": "Laatste 6 uur",
  "calendar.last7Days": "Laatste 7 dagen",
  "calendar.lastHour": "Laatste uur",
  "calendar.march": "Maart",
  "calendar.max": "Maximum",
  "calendar.may": "Mei",
  "calendar.month": "Maand",
  "calendar.monthTotal": "Maandtotaal",
  "calendar.morning": "Ochtend",
  "calendar.nextHours": "Komende uren",
  "calendar.night": "Nacht",
  "calendar.november": "November",
  "calendar.october": "Oktober",
  "calendar.oneDay": "1-daags",
  "calendar.oneHour": "1-uurs",
  "calendar.oneMonth": "1-maands",
  "calendar.oneWeek": "1-weeks",
  "calendar.periodRangeSpoken": "{start} tot en met {end}",
  "calendar.previous24Hours": "Voorgaande 24 uur",
  "calendar.previous30Days": "Voorgaande 30 dagen",
  "calendar.previous7Days": "Voorgaande 7 dagen",
  "calendar.previousDay": "Vorige dag",
  "calendar.previousHours": "Vorige uren",
  "calendar.previousMonth": "Vorige maand",
  "calendar.previousWeek": "Vorige week",
  "calendar.previousYear": "Vorig jaar",
  "calendar.sameDayLastYear": "Zelfde dag vorig jaar",
  "calendar.sameMonthLastYear": "Zelfde maand vorig jaar",
  "calendar.selectADate": "Selecteer een datum",
  "calendar.selectAggregation": "Selecteer weergegeven waarde",
  "calendar.selectAMonth": "Selecteer een maand",
  "calendar.selectAYear": "Selecteer een jaar",
  "calendar.selectGranularity": "Selecteer een schaalweergave",
  "calendar.selectPeriod": "Selecteer een periode",
  "calendar.september": "September",
  "calendar.sixHours": "6-uurs",
  "calendar.startTime": "Starttijd",
  "calendar.thirtyMinutes": "30-minuten",
  "calendar.threeHours": "3-uurs",
  "calendar.timezone": "Tijdzone",
  "calendar.today": "Vandaag",
  "calendar.untilChanged": "Tot gewijzigd",
  "calendar.untilTime": "Tot {time}",
  "calendar.untilTodayAt": "Tot vandaag om {time}",
  "calendar.untilTomorrowAt": "Tot morgen om {time}",
  "calendar.use24HourFormat": "Gebruik 24-uursnotatie",
  "calendar.week": "Week",
  "calendar.year": "Jaar",
  "calendar.yearToDate": "Sinds jaarbegin",
  "calendar.yesterday": "Gisteren",
  "charts.averageOverThePeriod": "Gemiddelde over de periode",
  "charts.calendarView": "Kalenderweergave",
  "charts.charts": "Grafieken",
  "charts.chartView": "Grafiekweergave",
  "charts.comparison": "Vergelijking",
  "charts.customizeComparisonMetrics": "Meetwaarden aanpassen",
  "charts.customizeComparisonMetricsDescription": "Sleep items om uw vergelijkingswaarden opnieuw in te delen. Tik op het oogpictogram om meetwaarden weer te geven of te verbergen.",
  "charts.maxOverThePeriod": "Maximum over de periode",
  "charts.measureToDisplay": "Weer te geven meetwaarde",
  "charts.minMaxRange": "Min. / Max.",
  "charts.noDataForThisPeriod": "Geen data voor deze periode",
  "charts.observations": "Waarnemingen",
  "charts.observedTemperature": "Gemeten temperatuur",
  "charts.showComparison": "Vergelijking tonen",
  "charts.stationComparison": "Stationsvergelijking",
  "charts.stationComparisonDescription": "Vergelijk historische weergegevens met een ander station",
  "charts.sumOverThePeriod": "Totaal over de periode",
  "charts.viewAsList": "Lijst",
  "charts.viewAsPeriods": "Dagdelen",
  "common.add": "Voeg toe",
  "common.altitude": "Hoogte",
  "common.analysis": "Analyse",
  "common.average": "Gemiddelde",
  "common.back": "Terug",
  "common.backToHome": "Terug naar Home",
  "common.cancel": "Annuleren",
  "common.cannotBeEmpty": "Dit veld kan niet leeg zijn.",
  "common.close": "Sluiten",
  "common.dailyForecast": "Dagelijkse voorspelling",
  "common.default": "Standaard",
  "common.delete": "Verwijderen",
  "common.details": "Details",
  "common.edit": "Wijzigen",
  "common.exitFullscreen": "Volledig scherm verlaten",
  "common.forecast": "Voorspelling",
  "common.frequency": "Frequentie",
  "common.full": "Vol",
  "common.fullscreen": "Volledig scherm",
  "common.help": "Help",
  "common.hidden": "Verborgen",
  "common.high": "Hoog",
  "common.iDontKnowYet": "Geen idee",
  "common.indoor": "Binnenshuis",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Laatste update",
  "common.low": "Laag",
  "common.maximum": "Maximum",
  "common.medium": "Gemiddeld",
  "common.minimum": "Minimum",
  "common.more": "Meer",
  "common.moreInformation": "Meer informatie",
  "common.next": "Volgende",
  "common.no": "Nee",
  "common.noAccountNeeded": "Geen account nodig",
  "common.noItemsAvailable": "Geen items beschikbaar",
  "common.notNow": "Niet nu",
  "common.now": "Nu",
  "common.openSettings": "Open instellingen",
  "common.outdoor": "Buiten",
  "common.pageNotFound": "Pagina niet gevonden",
  "common.pageNotFoundDescription": "De pagina die u zoekt bestaat niet of is verplaatst.",
  "common.rain": "Regen",
  "common.share": "Delen",
  "common.shareImageFailed": "De afbeelding kon niet worden gedeeld",
  "common.shareYourWeather": "Deel de weermetingen",
  "common.skip": "Overslaan",
  "common.start": "Begin",
  "common.unknown": "Onbekend",
  "common.validate": "Bevestigen",
  "common.validEmail": "Een geldig e-mailadres is verplicht.",
  "common.very_low": "Zeer laag",
  "common.weatherObservations": "Weerobservaties",
  "common.welcome": "Welkom bij SmartMixin!",
  "common.wind": "Wind",
  "common.yes": "Ja",
  "common.zoomImage": "Afbeelding vergroten",
  "compass.E": "O",
  "compass.E_long": "Oost",
  "compass.ENE": "ONO",
  "compass.ENE_long": "Oost-Noordoost",
  "compass.ESE": "OZO",
  "compass.ESE_long": "Oost-Zuidoost",
  "compass.N": "N",
  "compass.N_long": "Noord",
  "compass.NE": "NO",
  "compass.NE_long": "Noordoost",
  "compass.NNE": "NNO",
  "compass.NNE_long": "Noord-Noordoost",
  "compass.NNW": "NNW",
  "compass.NNW_long": "Noord-Noordwest",
  "compass.NW": "NW",
  "compass.NW_long": "Noordwest",
  "compass.S": "Z",
  "compass.S_long": "Zuid",
  "compass.SE": "ZO",
  "compass.SE_long": "Zuidoost",
  "compass.SSE": "ZZO",
  "compass.SSE_long": "Zuid-Zuidoost",
  "compass.SSW": "ZZW",
  "compass.SSW_long": "Zuid-Zuidwest",
  "compass.SW": "ZW",
  "compass.SW_long": "Zuidwest",
  "compass.W": "W",
  "compass.W_long": "West",
  "compass.WNW": "WNW",
  "compass.WNW_long": "West-Noordwest",
  "compass.WSW": "WZW",
  "compass.WSW_long": "West-Zuidwest",
  "dashboard.currentObservations": "Huidige waarnemingen",
  "dashboard.currentRainEvent": "Huidige regenactiviteit",
  "dashboard.currentWeatherConditions": "Huidig weer",
  "dashboard.customizeDashboard": "Aanpassen",
  "dashboard.customizeDashboardDescription": "Sleep items om uw dashboard te herordenen. Tik op het oogpictogram om secties te tonen of te verbergen.",
  "dashboard.dashboard": "Dashboard",
  "dashboard.dayRangeExpected": "{value} verwacht om {time}",
  "dashboard.dayRangeReached": "{value} om {time}",
  "dashboard.dayRangeSteady": "Stabiel op {value} de hele dag",
  "dashboard.hiddenSensors": "Verborgen sensoren",
  "dashboard.lastRainEvent": "Laatste regenactiviteit",
  "dashboard.manageSensors": "Sensoren beheren",
  "dashboard.manageSensorsDescription": "Sleep items om sensoren te herordenen. Tik op het oogpictogram om sensoren te tonen of verbergen. Tik op een naam om deze te hernoemen.",
  "dashboard.pressureSummary": "Drukoverzicht",
  "dashboard.rainEvents": "Regenactiviteiten",
  "dashboard.rainSummary": "Buienoverzicht",
  "dashboard.shareOutdoorMeasures": "Deel uw buitenmetingen",
  "dashboard.shareOutdoorMeasuresDescription": "Neem deel aan de SmartMixin-community door uw buitenmetingen zichtbaar te maken voor anderen. Metingen binnenshuis worden nooit gedeeld.",
  "dashboard.temperatureSummary": "Temperatuursoverzicht",
  "dashboard.windSummary": "Windoverzicht",
  "devices.batteryLevel": "Batterijniveau",
  "devices.firmwareVersion": "Firmwareversie",
  "devices.moduleCount": "{count, plural, one {# module} other {# modules}}",
  "devices.moduleType": "Type module",
  "devices.noNetatmoWeatherStationYet": "U heeft nog geen Netatmo-weerstation.",
  "devices.noOutdoorModule": "Er is geen werkende buitenmodule aanwezig bij dit station.",
  "devices.notReachable": "Niet bereikbaar",
  "devices.serialNumber": "Serienummer",
  "devices.signalAverage": "Matig",
  "devices.signalBad": "Zwak",
  "devices.signalGood": "Goed",
  "devices.signalStrength": "Signaalsterkte",
  "devices.signalUnknown": "Onbekend",
  "devices.visitNetatmoWebsite": "Bezoek de Netatmo-website",
  "devices.wifiStrength": "Wi-Fi-signaal",
  "forecastMaps.addColor": "Kleur toevoegen",
  "forecastMaps.addLayer": "Laag toevoegen",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Terug naar kaarten",
  "forecastMaps.build": "Genereren",
  "forecastMaps.buildCompleted": "Genereren voltooid",
  "forecastMaps.builderMetaDescription": "Stel eigen verwachtingskaarten samen uit de lagen van weermodellen.",
  "forecastMaps.builderTitle": "Kaartenbouwer",
  "forecastMaps.buildFailed": "Het genereren is mislukt. Probeer het opnieuw.",
  "forecastMaps.buildNotPossible": "Deze kaart kan nog niet worden gegenereerd — er zijn geen verwachtingsgegevens beschikbaar.",
  "forecastMaps.buildProgress": "Renderen… {completed}/{total} stappen",
  "forecastMaps.buildStarting": "Genereren wordt gestart…",
  "forecastMaps.byModel": "Per model",
  "forecastMaps.byZone": "Per zone",
  "forecastMaps.colormap": "Kleurenschaal",
  "forecastMaps.colormapCustom": "Aangepaste kleuren",
  "forecastMaps.colormapGroupDomain": "Weer-voorinstellingen",
  "forecastMaps.colormapGroupMatplotlib": "Wetenschappelijke voorinstellingen",
  "forecastMaps.colorScale": "Kleurenschaal",
  "forecastMaps.contourLevels": "Contourniveaus",
  "forecastMaps.countryCanada": "Canada",
  "forecastMaps.countryFrance": "Frankrijk",
  "forecastMaps.countryGermany": "Duitsland",
  "forecastMaps.countryItaly": "Italië",
  "forecastMaps.countryScandinavia": "Scandinavië",
  "forecastMaps.countrySpain": "Spanje",
  "forecastMaps.countrySwitzerland": "Zwitserland",
  "forecastMaps.countryUnitedStates": "Verenigde Staten",
  "forecastMaps.customColormapMinColors": "Een aangepaste kleurenschaal heeft minstens twee kleuren nodig",
  "forecastMaps.customExtent": "Aangepast gebied",
  "forecastMaps.displayName": "Weergavenaam",
  "forecastMaps.downscaling": "Uitdunningsfactor windvanen",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Gebied tekenen",
  "forecastMaps.east": "Oost",
  "forecastMaps.extentDrawHint": "Sleep op de kaart om het gebied te tekenen",
  "forecastMaps.extentInvalid": "West moet kleiner zijn dan oost en zuid kleiner dan noord",
  "forecastMaps.height": "Hoogte (inch)",
  "forecastMaps.hourOffset": "+{hour} u",
  "forecastMaps.invalidHexColor": "Ongeldige kleur — gebruik #RRGGBB",
  "forecastMaps.layers": "Lagen",
  "forecastMaps.layerTypeBarbs": "Windvanen",
  "forecastMaps.layerTypeContour": "Contourlijnen",
  "forecastMaps.layerTypeFilledContour": "Gevulde contouren",
  "forecastMaps.layerTypeMagnitude": "Magnitude",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vectorveld",
  "forecastMaps.leave": "Verlaten",
  "forecastMaps.levelsCount": "Aantal",
  "forecastMaps.levelsInvalid": "Ongeldige contourniveaus",
  "forecastMaps.levelsModeArange": "Vaste stap",
  "forecastMaps.levelsModeExplicit": "Expliciete waarden",
  "forecastMaps.levelsModeLinspace": "Gelijkmatig verdeeld (aantal)",
  "forecastMaps.levelsStep": "Stap",
  "forecastMaps.levelsValues": "Waarden",
  "forecastMaps.levelsValuesHint": "Kommagescheiden, oplopend",
  "forecastMaps.localTimeHint": "Weergegeven in uw lokale tijd",
  "forecastMaps.mapDescription": "Beschrijving",
  "forecastMaps.mapName": "Kaartnaam",
  "forecastMaps.mapNameRequired": "Voer een naam in",
  "forecastMaps.mapSettings": "Kaartinstellingen",
  "forecastMaps.mapView": "Interactieve kaart",
  "forecastMaps.maxLayersReached": "Deze kaart heeft het maximum van {max} lagen bereikt.",
  "forecastMaps.maxValue": "Maximumwaarde",
  "forecastMaps.memoryBudgetExceeded": "De resolutie overschrijdt het renderbudget — verlaag de DPI of de hoogte",
  "forecastMaps.memoryBudgetUsage": "Renderbudget: {percent}%",
  "forecastMaps.metaDescription": "Geanimeerde voorspellingskaarten op basis van weermodellen.",
  "forecastMaps.metric": "Meetwaarde",
  "forecastMaps.metricRequired": "Selecteer een meetwaarde",
  "forecastMaps.metricUnavailable": "Niet beschikbaar voor dit model",
  "forecastMaps.minBelowMax": "Min moet kleiner zijn dan max",
  "forecastMaps.minMaxRequired": "Min- en maxwaarden zijn verplicht voor dit laagtype",
  "forecastMaps.minValue": "Minimumwaarde",
  "forecastMaps.modelNoRun": "Nog geen voltooide run",
  "forecastMaps.moveLayerDown": "Omlaag",
  "forecastMaps.moveLayerUp": "Omhoog",
  "forecastMaps.myMaps": "Mijn kaarten",
  "forecastMaps.nanClipToMin": "Begrenzen op min",
  "forecastMaps.nanMask": "Maskeren",
  "forecastMaps.nanPolicy": "Ontbrekende gegevens",
  "forecastMaps.nanSkip": "Overslaan",
  "forecastMaps.noCompletedRun": "Deze kaart is nog niet gegenereerd. Kom binnenkort terug.",
  "forecastMaps.noLayers": "Nog geen lagen. Voeg een laag toe om te beginnen.",
  "forecastMaps.noMapsAvailable": "Er zijn nog geen voorspellingskaarten beschikbaar.",
  "forecastMaps.north": "Noord",
  "forecastMaps.opacity": "Dekking",
  "forecastMaps.overlayLegend": "Legenda",
  "forecastMaps.pause": "Pauze",
  "forecastMaps.play": "Afspelen",
  "forecastMaps.pointValueError": "De verwachting voor dit punt kon niet worden geladen.",
  "forecastMaps.pointValueLoading": "Verwachting laden…",
  "forecastMaps.pointValueUnavailable": "Geen gegevens voor dit tijdstip.",
  "forecastMaps.presets": "Voorinstellingen",
  "forecastMaps.preview": "Voorbeeld",
  "forecastMaps.previewEmptyHint": "Configureer minstens één geldige laag om een voorbeeld te renderen.",
  "forecastMaps.previewFailed": "Het voorbeeld is mislukt",
  "forecastMaps.previewHour": "Verwachtingsuur",
  "forecastMaps.previewRendering": "Voorbeeld wordt gerenderd…",
  "forecastMaps.projection": "Projectie",
  "forecastMaps.projectionLambertConformal": "Lambert conform",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografisch",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Noord-Amerika",
  "forecastMaps.removeColor": "Kleur verwijderen",
  "forecastMaps.removeLayer": "Laag verwijderen",
  "forecastMaps.retry": "Opnieuw proberen",
  "forecastMaps.run": "Run: {run}",
  "forecastMaps.save": "Opslaan",
  "forecastMaps.selectExtentOnMap": "Gebied op de kaart selecteren",
  "forecastMaps.south": "Zuid",
  "forecastMaps.title": "Voorspellingskaarten",
  "forecastMaps.uMetric": "U-component",
  "forecastMaps.unitConversion": "Eenheidsconversie",
  "forecastMaps.unitNone": "Geen",
  "forecastMaps.unsavedChangesBody": "U hebt niet-opgeslagen wijzigingen. Verlaten en verwerpen?",
  "forecastMaps.unsavedChangesTitle": "Niet-opgeslagen wijzigingen",
  "forecastMaps.useCurrentView": "Huidige weergave gebruiken",
  "forecastMaps.useModelDomain": "Uit: het volledige modeldomein wordt gebruikt",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U- en V-meetwaarden moeten verschillen",
  "forecastMaps.valueBetween": "Moet tussen {min} en {max} liggen",
  "forecastMaps.variable": "Variabele",
  "forecastMaps.viewMap": "Kaart bekijken",
  "forecastMaps.vMetric": "V-component",
  "forecastMaps.west": "West",
  "forecastMaps.windAnimation": "Windanimatie",
  "forecastModels.addForecastModel": "Model toevoegen",
  "forecastModels.atYourStations": "Beschikbaar bij uw stations",
  "forecastModels.coverageLoading": "Bepalen welke van uw stations elk model dekt…",
  "forecastModels.description_AROME": "Het convectie-oplossende model met hoge resolutie van Météo France boven West-Europa met een resolutie van 1,3 km. Het beste in zijn klasse voor korte-termijnvoorspellingen in Frankrijk; elke drie uur ververst.",
  "forecastModels.description_ARPEGE_EU": "Het Europese geneste domein van het ARPEGE-model van Météo France met een resolutie van 10 km. Voorspellingen op middellange termijn over Europa, viermaal per dag ververst.",
  "forecastModels.description_ARPEGE_GLOBAL": "Het wereldwijde numerieke weermodel van Météo France met een resolutie van 25 km, dat tot ongeveer 4 dagen loopt. Viermaal per dag ververst.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI van DMI: een convectie-oplossend model boven Noordwest-Europa — Denemarken, de Benelux, Ierland, het Verenigd Koninkrijk en Scandinavië — met een resolutie van 2 km dat tot 60 uur loopt, achtmaal per dag ververst. Bevat gewijzigde open data van DMI (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Het Global Deterministic Prediction System van Environment Canada: een wereldwijd model op middellange termijn met een resolutie van 15 km dat tot 10 dagen loopt, tweemaal per dag bijgewerkt.",
  "forecastModels.description_EC_HRDPS": "Het High Resolution Deterministic Prediction System van Environment Canada: een convectie-oplossend model boven Canada en het noorden van de Verenigde Staten met een resolutie van 2,5 km dat tot 48 uur loopt, viermaal per dag ververst.",
  "forecastModels.description_EC_RDPS": "Het Regional Deterministic Prediction System van Environment Canada: een model op middellange termijn boven Noord-Amerika met een resolutie van 10 km, viermaal per dag ververst.",
  "forecastModels.description_ECMWF_HRES": "Het toonaangevende hogeresolutiemodel (IFS) van het Europees Centrum voor Weersverwachtingen op Middellange Termijn, algemeen beschouwd als het beste mondiale verwachtingssysteem ter wereld. Dekt de hele planeet met een resolutie van 25 km tot 15 dagen vooruit, viermaal daags bijgewerkt. Bevat gewijzigde open data van ECMWF (CC BY 4.0).",
  "forecastModels.description_GFS": "Het vlaggenschipmodel op middellange termijn van NOAA. Bedekt de hele planeet met een resolutie van 25 km tot 16 dagen, viermaal per dag bijgewerkt.",
  "forecastModels.description_HRRR_CONUS": "De High-Resolution Rapid Refresh van NOAA: een convectie-oplossend model boven de continentale Verenigde Staten met een resolutie van 3 km, elk uur ververst. Het meest geschikt voor zeer korte termijn voorspellingen van onweersbuien en zwaar weer.",
  "forecastModels.description_ICON": "Het mondiale ICON-model van DWD met een resolutie van 13 km dat de hele planeet tot 7,5 dagen bestrijkt, vier keer per dag bijgewerkt. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I van ItaliaMeteo, samen met ARPAE beheerd: een convectie-oplossend model boven Italië met een resolutie van 2,2 km dat tot 72 uur loopt, tweemaal per dag ververst. Bevat open data van ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "De ICON-CH1-EPS-controlerun van MeteoSwiss: een convectie-oplossend model boven de Alpen met een resolutie van 1 km dat tot 33 uur loopt, elke drie uur ververst.",
  "forecastModels.description_ICON_CH2": "De ICON-CH2-EPS-controlerun van MeteoSwiss: een convectie-oplossend model boven de Alpen — Zwitserland en de omliggende Alpenregio — met een resolutie van 2,1 km dat tot 120 uur loopt, viermaal per dag ververst.",
  "forecastModels.description_ICON_DE": "Het convectie-oplossende model met hoge resolutie van DWD boven Duitsland en omliggende landen met een resolutie van 2,2 km. Korte-termijnvoorspellingen tweemaal per dag ververst. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "Het Europese geneste domein van het ICON-model van DWD met een resolutie van 7 km dat Europa en de Noord-Atlantische Oceaan bestrijkt. Voorspellingen op middellange termijn viermaal per dag ververst. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "De open weersvoorspellingsservice van het Noors Meteorologisch Instituut, die Noordse modellen met hoge resolutie combineert met ECMWF-gegevens om wereldwijde voorspellingen tot 10 dagen vooruit te bieden.",
  "forecastModels.description_MF_AROME_ANTILLES": "Genest AROME-domein boven de Franse Antillen (Guadeloupe, Martinique) met een resolutie van 2,5 km. Korte-termijnvoorspellingen viermaal per dag ververst.",
  "forecastModels.description_MF_AROME_GUYANE": "Genest AROME-domein boven Frans-Guyana met een resolutie van 2,5 km. Korte-termijnvoorspellingen viermaal per dag ververst.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Genest AROME-domein boven Nieuw-Caledonië met een resolutie van 2,5 km. Korte-termijnvoorspellingen viermaal per dag ververst.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Genest AROME-domein boven Frans-Polynesië met een resolutie van 2,5 km. Korte-termijnvoorspellingen viermaal per dag ververst.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Genest AROME-domein boven Réunion en Mayotte met een resolutie van 2,5 km. Korte-termijnvoorspellingen viermaal per dag ververst.",
  "forecastModels.description_RRFS_CONUS": "NOAA's Rapid Refresh Forecast System boven de continentale Verenigde Staten met 3 km resolutie. Uurlijkse verwachtingen, achtmaal per dag ververst, tot 84 uur bij de vier hoofdruns en 18 uur bij de overige.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "NOAA's Rapid Refresh Forecast System voor heel Noord-Amerika met 13 km resolutie. Uurlijkse verwachtingen tot 84 uur, viermaal per dag ververst.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "De vlaggenschipvoorspelling van SmartMixin. Voor elk uur op uw locatie kiezen we het beste beschikbare model — meestal een regionaal model met hoge resolutie waar er een bestaat (AROME in Frankrijk, ICON-D2 in Duitsland, HRRR in de Verenigde Staten, ARPEGE Europe over het hele continent…) en vallen elders terug op een wereldwijd model — vervolgens vullen we eventuele hiaten uit naburige bronnen. Het resultaat is één naadloze voorspelling die overal ter wereld tot 14 dagen bestrijkt, automatisch ververst telkens wanneer een van de onderliggende modellen wordt bijgewerkt.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Weatherflows eigen wereldwijde voorspelling die meerdere numerieke weermodellen combineert met observaties van zijn Tempest-weerstationnetwerk. 10-daagse wereldwijde horizon.",
  "forecastModels.everywhereElse": "Overal elders",
  "forecastModels.everywhereElseFoot": "Wordt gebruikt bij elk station dat uw voorkeursmodellen niet bereiken.",
  "forecastModels.everywhereElsePick": "Kies er één",
  "forecastModels.fallbackBlend": "SmartMixin-mix",
  "forecastModels.fallbackBlendSub": "Combineert meerdere modellen, elk waar het het sterkst is.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES overal waar het reikt.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "Het wereldwijde model van de NOAA. Wat elk account vandaag gebruikt.",
  "forecastModels.fallbackResolution": "Hoogste resolutie",
  "forecastModels.fallbackResolutionSub": "Het fijnste raster dat bij elk station beschikbaar is.",
  "forecastModels.forecastChipLabelWithRun": "{model}, run {run}",
  "forecastModels.forecastChipRunHint": "Lang indrukken om de nieuwste run te tonen of te verbergen",
  "forecastModels.forecastComparisonDescription": "Vergelijk eenvoudig de uitvoer van prognosemodellen uit verschillende bronnen",
  "forecastModels.forecastFollowingPreferences": "Volgens uw voorkeuren",
  "forecastModels.forecastModel": "Voorspellingsmodel",
  "forecastModels.forecastModelComparison": "Vergelijking van prognosemodellen",
  "forecastModels.forecastModelCoverage": "Dekking",
  "forecastModels.forecastModelDescription": "Beschrijving",
  "forecastModels.forecastModels": "Voorspellingsmodellen",
  "forecastModels.forecastModelScopeGlobal": "Wereldwijd",
  "forecastModels.forecastModelScopeGlobalDescription": "Dit model bestrijkt de hele planeet.",
  "forecastModels.forecastModelScopeRegional": "Regionaal",
  "forecastModels.forecastModelScopeRegionalDescription": "Dit model bestrijkt slechts een specifieke regio.",
  "forecastModels.forecastModelSpecifications": "Specificaties",
  "forecastModels.forecastNoPinLocation": "Geen voorkeursmodel bereikt deze locatie — 'overal elders' beslist.",
  "forecastModels.forecastNoPinStation": "Geen voorkeursmodel bereikt dit station — 'overal elders' beslist.",
  "forecastModels.forecastNoPreferredModels": "Nog geen voorkeursmodellen ingesteld.",
  "forecastModels.forecastOverrideElsewhere": "Uw voorkeuren gelden overal elders.",
  "forecastModels.forecastPickForLocation": "Of kies er een voor deze locatie",
  "forecastModels.forecastPickForStation": "Of kies er een voor dit station",
  "forecastModels.forecastPinWinsLocation": "{model} — uw eerste voorkeursmodel dat deze locatie bereikt.",
  "forecastModels.forecastPinWinsStation": "{model} — uw eerste voorkeursmodel dat dit station bereikt.",
  "forecastModels.forecastServedNowHere": "Op dit moment is dat hier {model}",
  "forecastModels.forecastSetForLocation": "Ingesteld voor deze locatie",
  "forecastModels.forecastSetForStation": "Ingesteld voor dit station",
  "forecastModels.forecastSettingsRowSub": "Voorkeursmodellen, en wat overal elders geldt",
  "forecastModels.forecastStopUsingHere": "Hier niet meer gebruiken",
  "forecastModels.forecastUseForLocation": "{model} gebruiken voor deze locatie",
  "forecastModels.forecastUseForStation": "{model} gebruiken voor dit station",
  "forecastModels.forecastUsePreferred": "Mijn voorkeursmodellen gebruiken",
  "forecastModels.frequencyHourly": "Elk uur",
  "forecastModels.horizon": "Horizon",
  "forecastModels.horizonValue": "tot {value} uur",
  "forecastModels.meshSize": "Rastergrootte",
  "forecastModels.pickerShowAll": "Volledige catalogus tonen",
  "forecastModels.pickerUnreachable": "{count, plural, one {# ander model bereikt} other {# andere modellen bereiken}} geen van uw stations",
  "forecastModels.pinInUse": "In gebruik",
  "forecastModels.pinShadowed": "Nooit gebruikt — een model hierboven dekt al uw stations",
  "forecastModels.pinSlots": "{used} van {max} · kies een model",
  "forecastModels.pinSlotsFull": "{max, plural, one {De enige plaats is bezet. Verwijder het model om een ander toe te voegen.} other {Alle # plaatsen zijn bezet. Verwijder er één om een andere toe te voegen.}}",
  "forecastModels.pinsUncoveredCount": "{used} van uw {count, plural, one {# station} other {# stations}}: geen voorkeursmodel bereikt {used, plural, one {dit} other {deze}} — 'overal elders' beslist.",
  "forecastModels.pinsUncoveredNamed": "{stations}: geen voorkeursmodel bereikt {count, plural, one {dit} other {deze}} — 'overal elders' beslist.",
  "forecastModels.pinUnreachable": "Nooit gebruikt — het bereikt geen van uw stations",
  "forecastModels.pinUsedAt": "Gebruikt bij {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Gebruikt bij uw station} other {Gebruikt bij alle # stations}}",
  "forecastModels.pinUsedAtSome": "Gebruikt bij {used} van {count, plural, one {# station} other {# stations}}",
  "forecastModels.preferredModels": "Voorkeursmodellen",
  "forecastModels.preferredModelsAll": "Eén lijst, alle stations",
  "forecastModels.preferredModelsOne": "Eén lijst, geldt overal",
  "forecastModels.publisher": "Uitgever",
  "forecastModels.removePreferredModel": "{model} uit uw voorkeursmodellen verwijderen",
  "forecastModels.resetForecastPreference": "Standaard herstellen",
  "forecastModels.resetForecastPreferenceHint": "Wist uw voorkeursmodellen en keert terug naar de SmartMixin-standaard.",
  "forecastModels.servedNowMany": "Op dit moment: GFS {count, plural, one {bij uw station} other {bij alle # stations}}.",
  "forecastModels.servedNowNone": "Op dit moment: overal GFS.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multimodel",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Weatherflow-verwachting",
  "forecastModels.weatherForecastModels": "Weersvoorspellingsmodellen",
  "helpCenter.articleCount": "{count, plural, one {# artikel} other {# artikelen}}",
  "helpCenter.articleNotFound": "Artikel niet gevonden",
  "helpCenter.articleNotFoundDescription": "Het artikel dat u zoekt bestaat niet.",
  "helpCenter.backToHelpCenter": "Terug naar helpcentrum",
  "helpCenter.browseByCategory": "Bladeren op categorie",
  "helpCenter.categoryNotFound": "Categorie niet gevonden",
  "helpCenter.categoryNotFoundDescription": "Deze categorie bestaat niet of bevat geen artikelen.",
  "helpCenter.contactSupport": "Contact opnemen met support",
  "helpCenter.feedbackHelpsImprove": "Uw input helpt ons onze helpartikelen te verbeteren.",
  "helpCenter.feedbackReasonNotAnswer": "Het beantwoordt mijn vraag niet",
  "helpCenter.feedbackReasonOutdated": "De informatie is verouderd",
  "helpCenter.feedbackReasonUnclear": "De instructies zijn onduidelijk",
  "helpCenter.feedbackWhatWentWrong": "Wat was het probleem?",
  "helpCenter.helpCategoryAccount": "Account",
  "helpCenter.helpCategoryBilling": "Facturering",
  "helpCenter.helpCategoryForecast": "Voorspellingen",
  "helpCenter.helpCategoryGettingStarted": "Aan de slag",
  "helpCenter.helpCategoryProviders": "Providers",
  "helpCenter.helpCategoryStations": "Stations",
  "helpCenter.helpCategoryTroubleshooting": "Probleemoplossing",
  "helpCenter.helpCenter": "Helpcentrum",
  "helpCenter.landingDescription": "Vind antwoorden op veelgestelde vragen en leer hoe u het meeste uit SmartMixin haalt.",
  "helpCenter.linkToSection": "Link naar deze sectie",
  "helpCenter.menuItemDescription": "Veelgestelde vragen en handleidingen",
  "helpCenter.minRead": "{minutes} min leestijd",
  "helpCenter.onThisPage": "Op deze pagina",
  "helpCenter.platformMobileApp": "Mobiele app",
  "helpCenter.platformMobileOnly": "Alleen in de mobiele app",
  "helpCenter.platformWebApp": "Webapp",
  "helpCenter.platformWebOnly": "Alleen in de webapp",
  "helpCenter.popularArticles": "Populaire artikelen",
  "helpCenter.relatedArticles": "Gerelateerde artikelen",
  "helpCenter.searchArticles": "Artikelen zoeken...",
  "helpCenter.stillNeedHelp": "Nog steeds hulp nodig?",
  "helpCenter.stillNeedHelpDescription": "Als dit artikel uw vraag niet heeft beantwoord, help ik u graag persoonlijk verder.",
  "helpCenter.supportEmailSubject": "SmartMixin-hulp",
  "helpCenter.supportEmailSubjectTopic": "SmartMixin-hulp — {topic}",
  "helpCenter.thankYouForFeedback": "Bedankt voor uw feedback!",
  "helpCenter.wasArticleHelpful": "Was dit artikel nuttig?",
  "intro.locationDescription": "Sta locatievoorziening toe voor nauwkeurige weersvoorspellingen die zijn afgestemd op jouw exacte gebied — geen one‑size‑fits‑all voorspellingen meer.",
  "intro.locationTitle": "Voorspellingen op maat voor jou",
  "intro.notificationDescription": "Schakel meldingen in voor tijdige waarschuwingen over weersveranderingen die er voor jou toe doen — regen, sneeuw of ernstige omstandigheden, precies wanneer je het nodig hebt.",
  "intro.notificationsTitle": "Mis nooit een weersverandering",
  "intro.readyDescription": "Geniet van nauwkeurige voorspellingen, realtime weersinzichten en stationgegevens van over de hele wereld — alles in één krachtige app.",
  "intro.readyTitle": "Je bent er klaar voor!",
  "intro.welcomeDescription": "Ontvang hyperlokale voorspellingen van toonaangevende meteorologische diensten — plus toegang tot meer dan 40.000 weerstations wereldwijd om echte omstandigheden te zien, heden en verleden.",
  "intro.welcomeTitle": "Jouw weer, opnieuw bedacht",
  "landing.alsoAvailableOn": "Ook beschikbaar op:",
  "landing.featureAlertsDescription": "Stel aangepaste drempelwaarden in voor elke meetwaarde. Ontvang een melding wanneer de temperatuur daalt, het begint te regenen of de wind aantrekt.",
  "landing.featureAlertsTitle": "Slimme waarschuwingen",
  "landing.featureAnalyticsDescription": "Interactieve grafieken, trendanalyse en gedetailleerde statistieken. Duik diep in gegevens over temperatuur, luchtvochtigheid, luchtdruk, regen en wind.",
  "landing.featureAnalyticsTitle": "Geavanceerde analyses",
  "landing.featureExportDescription": "Ontvang al uw weergegevens per e-mail als Excel-spreadsheet, klaar voor verdere analyse in Excel, Google Spreadsheets of uw favoriete tools.",
  "landing.featureExportTitle": "Exporteer uw gegevens",
  "landing.featureForecastDescription": "Toegang tot {count, plural, one {#+ professioneel voorspellingsmodel} other {#+ professionele voorspellingsmodellen}}, waaronder ECMWF, GFS en regionale modellen. Vergelijk ze naast elkaar en maak uw eigen voorspellingen.",
  "landing.featureForecastTitle": "Vergelijk voorspellingsmodellen",
  "landing.featureHistoryDescription": "Toegang tot historische gegevens met uur-, dag- en maandschaal. Exporteer ze naar Excel voor onderzoek of persoonlijke archieven.",
  "landing.featureHistoryTitle": "Rijke geschiedenis",
  "landing.featureMultiBrandDescription": "Verbind Netatmo, Davis, Tempest, Ecowitt, Ambient Weather en meer. Nooit meer schakelen tussen apps.",
  "landing.featureMultiBrandTitle": "Alle merken, één app",
  "landing.featuresSubtitle": "SmartMixin geeft u de tools om uw weergegevens als een professional te analyseren, te vergelijken en te begrijpen.",
  "landing.featuresTitle": "Gemaakt voor dataliefhebbers",
  "landing.finalCtaButton": "Gratis account aanmaken",
  "landing.finalCtaSubtitle": "Sluit u aan bij duizenden weerenthousiastelingen die op SmartMixin vertrouwen.",
  "landing.finalCtaTitle": "Klaar om dieper in uw weergegevens te duiken?",
  "landing.heroCta": "Gratis beginnen",
  "landing.heroDescription": "Diepgaande analyses, prachtige grafieken en professionele voorspellingen — al uw weerstations samen in één krachtige app.",
  "landing.heroSecondaryCta": "De kaart verkennen",
  "landing.heroTagline": "Voor weerliefhebbers",
  "landing.heroTitle": "Bekijk uw weer als nooit tevoren",
  "landing.pricingFeatureAdvancedMetrics": "Geavanceerde metingen",
  "landing.pricingFeatureAlerts": "Aangepaste waarschuwingen",
  "landing.pricingFeatureExport": "Gegevensexport (Excel)",
  "landing.pricingFeatureForecastComparison": "Prognosevergelijking",
  "landing.pricingFeatureForecasts": "Voorspellingsmodellen",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ model} other {#+ modellen}}",
  "landing.pricingFeatureReports": "Analyses & rapporten",
  "landing.pricingFeatureStationComparison": "Stationsvergelijking",
  "landing.pricingFeatureWidgets": "Startscherm-widgets",
  "landing.pricingFeatureYearOverYear": "Jaarlijkse vergelijking",
  "landing.pricingFreeCta": "Aan de slag",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Meest populair",
  "landing.pricingPremiumCta": "Aan de slag",
  "landing.pricingPremiumDescription": "Vanaf 1,99 €/maand — abonneer via web, App Store of Google Play",
  "landing.pricingSubtitle": "Begin gratis, upgrade wanneer u meer nodig hebt.",
  "landing.pricingTitle": "Eenvoudige, transparante prijzen",
  "landing.statBrands": "Ondersteunde merken",
  "landing.statForecasts": "Voorspellingsmodellen",
  "landing.statStations": "Weerstations",
  "landing.supportedDevicesNote": "Plus meer dan {count, number} openbare stations uit het netwerk van de Wereld Meteorologische Organisatie",
  "landing.supportedDevicesSubtitle": "Verbind uw bestaande weerstation binnen enkele minuten. We ondersteunen {count, plural, one {# groot merk} other {# grote merken}}, en dat worden er steeds meer.",
  "landing.supportedDevicesTitle": "Werkt met uw station",
  "metrics.absolutePressure": "Absolute druk",
  "metrics.airDensity": "Luchtdichtheid",
  "metrics.airGap": "Luchtspleet",
  "metrics.apparentTemperature": "Gevoelstemperatuur",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Gem.",
  "metrics.avg_wind": "Gemiddelde wind",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Zwarte bol temp.",
  "metrics.boilerOn": "Verwarming AAN",
  "metrics.boilerOnInHours": "Verwarming AAN (uren)",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Geleidbaarheid",
  "metrics.dailyPrecipitation": "Dagelijkse neerslag",
  "metrics.dailyRain": "Dagelijkse neerslag",
  "metrics.degreeDayShort": "DD",
  "metrics.depth": "Diepte",
  "metrics.depthSensors": "Dieptesensoren",
  "metrics.dewPoint": "Dauwpunt",
  "metrics.distance": "Afstand",
  "metrics.downTrend": "dalend",
  "metrics.ET": "Evapotranspiratie",
  "metrics.etToday": "ET vandaag",
  "metrics.feelsLike": "Gevoel",
  "metrics.feelsLikeWithFormula": "Gevoel ({formula})",
  "metrics.frostPoint": "Vorstpunt",
  "metrics.gust": "Windstoot",
  "metrics.hail": "Hagel",
  "metrics.heatIndex": "Hitte-index",
  "metrics.heatingDegreeDays": "Verwarmingsgraaddagen",
  "metrics.heatingPower": "Verwarmingsvermogen",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Luchtvochtigheid",
  "metrics.lastLightningImpact": "Laatste inslag",
  "metrics.lastMeasure": "Laatste meting",
  "metrics.leafSensors": "Bladsensor",
  "metrics.leafWetness": "Bladvochtigheid",
  "metrics.lightningDistance": "Afstand",
  "metrics.lightningStrikeCount": "Aantal bliksemontladingen",
  "metrics.lightningStrikeDistance": "Afstand bliksemontladingen",
  "metrics.max": "Max.",
  "metrics.max_gust": "Max. windstoot",
  "metrics.maxToday": "Max. vandaag",
  "metrics.min": "Min.",
  "metrics.noise": "Geluid",
  "metrics.normalizedHeatingCoefficient": "Genormaliseerde opwarmingscoëfficiënt",
  "metrics.outdoorTemperature": "Buitentemperatuur",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2.5",
  "metrics.precipitation": "Neerslag",
  "metrics.pressure": "Luchtdruk",
  "metrics.rain": "Neerslag",
  "metrics.rainDurationValue": "Regenduur: {duration}",
  "metrics.rainfallMeasurement": "Regenmeting",
  "metrics.rainRate": "Regenintensiteit",
  "metrics.relativePressure": "Relatieve luchtdruk",
  "metrics.setPoint": "Setpunt",
  "metrics.snow": "Sneeuw",
  "metrics.snowfall": "Sneeuwval",
  "metrics.soilMoisture": "Vocht",
  "metrics.soilSensors": "Bodemsensoren",
  "metrics.soilWaterTension": "Bodemwaterspanning",
  "metrics.solarEnergy": "Zonne-energie",
  "metrics.solarRadiation": "Zonnestraling",
  "metrics.speed": "Snelheid",
  "metrics.stableTrend": "Stabiel",
  "metrics.sum": "Som",
  "metrics.temperature": "Temperatuur",
  "metrics.temperatureSensors": "Temperatuur- en luchtvochtigheidssensoren",
  "metrics.temperatureShort": "Temp.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "stijgend",
  "metrics.uv": "UV",
  "metrics.visibility": "Zicht",
  "metrics.weatherCondition": "Weersgesteldheid",
  "metrics.wetBulbGlobeTemperature": "WBG Temperatuur",
  "metrics.wetBulbTemperature": "WB Temperatuur",
  "metrics.wind": "Wind",
  "metrics.windChill": "Windchill",
  "metrics.windDirection": "Windrichting",
  "metrics.windMeasurement": "Windmeting",
  "metrics.windRun": "Windloop",
  "metrics.windRunDescription": "De windloop is de totale afstand die de wind in een bepaalde periode aflegt",
  "metrics.windSpeed": "Windsnelheid",
  "network.cancelError": "Verzoek is geannuleerd",
  "network.connectionError": "Server niet beschikbaar",
  "network.networkError": "Netwerk niet beschikbaar",
  "network.serverError": "Er is iets misgegaan...",
  "network.timeoutError": "Verbinding time-out",
  "network.unknownError": "Onbekende fout",
  "premium.alreadyPremium": "U heeft al een premium account!",
  "premium.bestValue": "Beste koop",
  "premium.billingDetailsAndroid": "Gratis proefperiode: er worden geen kosten in rekening gebracht als u ten minste 24 uur voor het einde van de proefperiode opzegt. Daarna wordt uw SmartMixin-abonnement automatisch verlengd, tenzij u het ten minste 24 uur voor het einde van de lopende periode opzegt; opzeggen kan op elk moment in de instellingen van uw Google Play-account. Elke verlenging wordt in rekening gebracht tegen de prijs op de knop hierboven. De betaling wordt via uw Google Play-account in rekening gebracht wanneer u de aankoop bevestigt en aan het begin van elke verlengingsperiode.",
  "premium.billingDetailsIos": "Gratis proefperiode: er worden geen kosten in rekening gebracht als u ten minste 24 uur voor het einde van de proefperiode opzegt. Daarna wordt uw SmartMixin-abonnement automatisch verlengd, tenzij u het ten minste 24 uur voor het einde van de lopende periode opzegt; opzeggen kan op elk moment in de instellingen van uw App Store-account. Elke verlenging wordt in rekening gebracht tegen de prijs op de knop hierboven. De betaling wordt via uw App Store-account in rekening gebracht wanneer u de aankoop bevestigt en aan het begin van elke verlengingsperiode.",
  "premium.freeBannerBody": "Gratis accounts krijgen overal GFS — uw voorkeursmodellen en 'overal elders' gaan werken zodra u zich abonneert.",
  "premium.freeBannerTitle": "Voorkeuren gelden met Premium",
  "premium.freeSubscription": "Gratis premiumabonnement",
  "premium.freeTrialForPeriod": "Gratis proefperiode van {period, plural, one {# dag} other {# dagen}}",
  "premium.getUnlimitedAccess": "Onbeperkte toegang tot:",
  "premium.manageMySubscription": "Mijn abonnement beheren",
  "premium.notPurchasedYet": "Er is voor dit winkelaccount geen aankoop van SmartMixin Premium gevonden.",
  "premium.orChooseMonthly": "Of kies maandelijks:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Actief",
  "premium.premiumAnnualTrialInfo": "Begin met een gratis proefperiode van {days, plural, one {# dag} other {# dagen}}",
  "premium.premiumCurrentPlan": "Huidig abonnement",
  "premium.premiumDownloadApp": "Download de app om te abonneren:",
  "premium.premiumEndsOn": "Verloopt op {date}",
  "premium.premiumFeatureAlerts": "Weerwaarschuwingen",
  "premium.premiumFeatureAnalysis": "Geavanceerde weeranalyse",
  "premium.premiumFeatureCharts": "Grafiekvergelijkingen",
  "premium.premiumFeatureExport": "Gegevensexport",
  "premium.premiumFeatureForecast": "Regionale voorspellingsmodellen",
  "premium.premiumFeatureNotification": "Statusbalk-widget",
  "premium.premiumFeatureTitle": "Premiumfunctie",
  "premium.premiumFeatureWidgets": "Startscherm-widgets",
  "premium.premiumFreePlan": "Gratis",
  "premium.premiumInactive": "Niet geabonneerd",
  "premium.premiumManageStoreSubscription": "U hebt een abonnement via {store}. Beheer of annuleer uw abonnement daar.",
  "premium.premiumManageWebSubscription": "Beheer uw abonnement, werk de betaalmethode bij of annuleer.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Verlenging op {date}",
  "premium.premiumSubscribeAnnual": "Jaarlijks — 9,99 €/jaar",
  "premium.premiumSubscribedOn": "Geabonneerd op {platform}",
  "premium.premiumSubscribedOnWeb": "Geabonneerd via het web",
  "premium.premiumSubscribeMonthly": "Maandelijks — 1,99 €/maand",
  "premium.premiumSubscribeOnWeb": "Abonneer nu om alle premiumfuncties te ontgrendelen.",
  "premium.premiumSubscriptionSuccess": "Uw abonnement is geactiveerd! Geniet van alle premiumfuncties.",
  "premium.premiumSubscriptionSuccessTitle": "Welkom bij Premium!",
  "premium.premiumWebappNotice": "Abonneren via het web is op dit moment niet beschikbaar.",
  "premium.pricePerMonth": "{price}/maand",
  "premium.pricePerYear": "{price}/jaar",
  "premium.purchasedNetatmoPro": "U heeft eerder Netatmo Pro aangeschaft ({date}). Dit geeft toegang tot een subset van premiumfuncties. Abonneer u op een van de volgende aanbiedingen als u toegang wilt hebben tot alle premiumfuncties.",
  "premium.purchaseFailed": "Uw aankoop kon niet worden voltooid. Probeer het opnieuw.",
  "premium.restoreFailed": "Uw aankopen konden niet worden hersteld. Probeer het opnieuw.",
  "premium.restorePurchase": "Herstel aankoop",
  "premium.savingsPercent": "Bespaar {percent}%",
  "premium.seePremium": "Bekijk Premium",
  "premium.startFreeTrial": "Gratis proefperiode starten",
  "premium.storeUnavailable": "De winkel is momenteel niet beschikbaar. Probeer het later opnieuw.",
  "premium.subscribeNow": "Nu abonneren — zonder proefperiode",
  "premium.switchToPremium": "Overstappen naar SmartMixin Premium",
  "premium.thenPrice": "daarna {price}",
  "providerHints.ambientWeatherApiKey": "Aangemaakt in de instellingen van uw ambientweather.net-account.",
  "providerHints.davisApiSecret": "Wordt slechts één keer getoond bij het aanmaken van de V2 API-sleutel — bewaar het veilig.",
  "providerHints.davisV2ApiKey": "Van de V2 API-sleutelpagina op weatherlink.com.",
  "providerHints.ecowittApi": "Van de API-pagina van uw Ecowitt-account.",
  "providerHints.ecowittApp": "De applicatiesleutel, ook uit uw Ecowitt-account.",
  "providerHints.myAcuriteCredentialsBanner": "Gebruik e-mail en wachtwoord van uw My AcuRite-account — niet uw SmartMixin-login.",
  "providerHints.myAcuriteEmail": "Het e-mailadres van uw My AcuRite-account — niet uw SmartMixin-login.",
  "providerHints.myAcuritePassword": "Het wachtwoord van uw My AcuRite-account.",
  "providerHints.weatherflowToken": "Persoonlijk token van tempestwx.com → instellingen → gegevensautorisaties.",
  "providerHints.wundergroundEditKey": "Een andere sleutel gebruiken",
  "providerHints.wundergroundKey": "Een lange reeks van uw Weather Underground API-sleutelpagina — niet uw wunderground.com-wachtwoord.",
  "providerHints.wundergroundKeyExample": "bijv. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-sleutel geverifieerd",
  "providerHints.wundergroundNoStationsNearby": "Geen stations gevonden in de buurt. Probeer rechtstreeks een stations-ID in te voeren.",
  "providerHints.wundergroundStationIdExample": "bijv. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Haal uw Ambient Weather API-sleutel op.",
  "providerIntro.davisStep2": "Haal uw Davis V2 API-sleutel en API-secret op.",
  "providerIntro.ecowittStep2": "Haal uw Ecowitt API-sleutel en applicatiesleutel op.",
  "providerIntro.getStarted": "Aan de slag",
  "providerIntro.myAcuriteStep2": "Gebruik e-mail en wachtwoord van uw bestaande My AcuRite-account.",
  "providerIntro.netatmoEnergyStep2": "Log in bij Netatmo wanneer hierom wordt gevraagd — geen API-sleutel nodig.",
  "providerIntro.netatmoWeatherStep2": "Log in bij Netatmo wanneer hierom wordt gevraagd — geen API-sleutel nodig.",
  "providerIntro.signupBanner": "Bijna klaar — maak uw gratis SmartMixin-account aan om {provider} te verbinden.",
  "providerIntro.step1": "Log in op uw SmartMixin-account (NIET uw {provider}-login).",
  "providerIntro.step3EmailPassword": "Voer ze hier in.",
  "providerIntro.step3KeyOrToken": "Plak het hier.",
  "providerIntro.step3OAuth": "Geef SmartMixin toestemming in het pop-upvenster.",
  "providerIntro.step3Wunderground": "Plak uw API-sleutel en kies dan een station in de buurt of voer een willekeurige stations-ID in.",
  "providerIntro.title": "{provider} verbinden",
  "providerIntro.weatherflowStep2": "Haal uw persoonlijke Tempest-token op.",
  "providerIntro.wundergroundBrowsePublic": "Geen station? Bekijk de openbare stations",
  "providerIntro.wundergroundFindNearby": "Stations bij mij in de buurt zoeken",
  "providerIntro.wundergroundOrEnterId": "Of voer een stations-ID in",
  "providerIntro.wundergroundStep2": "Haal uw Weather Underground API-sleutel op. Daarna kunt u elk station verbinden — uw eigen of een openbaar station.",
  "reports.agroMeteorology": "Agrometeorologie",
  "reports.analysis": "Analyse",
  "reports.annualCumulativeRainfallComparison": "Jaarlijkse cumulatieve neerslagvergelijking",
  "reports.annualHeatingDurationComparison": "Vergelijking van de jaarlijkse verwarmingsduur",
  "reports.annualHeatingEfficiency": "Jaarlijks verwarmingsrendement",
  "reports.annualIndoorComparison": "Jaarlijkse vergelijking binnenshuis",
  "reports.annualOutdoorComparison": "Jaarlijkse vergelijk buitenshuis",
  "reports.annualOutdoorReport": "Jaarlijks overzicht buitenshuis",
  "reports.annualReport": "Jaarlijks overzicht",
  "reports.annualSolarReport": "Jaarlijks overzicht zonneschijn",
  "reports.annualWaterBalance": "Jaarlijkse waterbalans",
  "reports.annualWaterBalanceCarryOver": "{year} overdragen ({value})",
  "reports.annualWaterBalanceDescription": "De waterbalans (vereenvoudigde versie, alleen regen en evapotranspiratie worden gebruikt) helpt bij het beheer van de watervoorziening",
  "reports.avgHumidity": "Gemiddelde luchtvochtigheid",
  "reports.avgMaxTemperature": "Gemiddelde T°max",
  "reports.avgMetric": "Gemiddelde {metric}",
  "reports.avgMinTemperature": "Gemiddelde T°min",
  "reports.avgPressure": "Gemiddelde luchtdruk",
  "reports.avgTemperature": "Gemiddelde temperatuur",
  "reports.chartsAndTable": "Grafieken en tabel",
  "reports.climateNormalPeriodOfRecord": "Meetperiode ({years} jaar)",
  "reports.climateNormals": "Klimaatnormalen",
  "reports.climateNormalStandardLabel": "Normaalperiode ({period})",
  "reports.climateTrendPerDecade": "Temperatuurtrend: {value} per decennium over {years} jaar",
  "reports.coldestMonthRanking": "Koudste {month} ooit gemeten",
  "reports.comfortable": "Comfortabele (45% {lessThan} Luchtvochtigheid ≤ 60%)",
  "reports.cumulativeRainfall": "Cumulatieve neerslag",
  "reports.cumulativeRainfallDescription": "Volg de totale neerslag die zich opbouwt over de geselecteerde periode.",
  "reports.dailyMaxRainfall": "Dagelijkse maximale neerslag",
  "reports.dataExport": "Exporteer data",
  "reports.dataExportXlsxFormatDescription": "Exporteer alle gegevens van uw station in Excel-formaat (*.xlsx). Zodra u op de knop klikt, ontvangt u na enkele minuten een e-mail met de verwerkte gegevens.",
  "reports.daysOfData": "{days, plural, one {# dag aan gegevens} other {# dagen aan gegevens}}",
  "reports.daysWithFrost": "Dagen met vorst",
  "reports.daysWithHeavyRain": "Dagen met zware regen (≥ {threshold})",
  "reports.daysWithoutThaw": "Dagen zonder dooi",
  "reports.daysWithStrongFrost": "Dagen met strenge vorst",
  "reports.emailSent": "Een email is naar u toegezonden",
  "reports.frostDays": "Vorstdagen",
  "reports.grasslandTemperatureSum": "Som van de grasland temperatuur",
  "reports.grasslandTemperatureSumDescription": "Als de som van {threshold} in het voorjaar wordt overschreden, is de duurzame start van de vegetatie bereikt (werkt in Europa)",
  "reports.growingDegreeDays": "Groeigraaddagen",
  "reports.highPressure": "Anticycloon (gemiddelde druk ≥ 1013 mbar)",
  "reports.iceDays": "IJsdagen",
  "reports.indoorReport": "Overzicht binnenshuis",
  "reports.keyFacts": "Belangrijkste gegevens",
  "reports.longestDrySpell": "Langste droge periode",
  "reports.longestRunOfRainyDays": "Langste reeks regenachtige dagen",
  "reports.longestRunWithoutRun": "Langste reeks droge dagen",
  "reports.longestWetSpell": "Langste natte periode",
  "reports.lowPressure": "Lage druk (gemiddelde druk {lessThan} 1013 mbar)",
  "reports.maxHumidity": "Maximale luchtvochtigheid",
  "reports.maxMetric": "Maximum {metric}",
  "reports.maxPressure": "Maximale luchtdruk",
  "reports.maxTemperature": "Maximum temperatuur",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maximale amplitude (/24H)",
  "reports.minHumidity": "Minimale luchtvochtigheid",
  "reports.minMetric": "Minimum {metric}",
  "reports.minPressure": "Minimale luchtdruk",
  "reports.minTemperature": "Minimum temperatuur",
  "reports.minTempMagnitude24h": "Minimale amplitude (/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Nog # dag} other {Nog # dagen}} deze maand",
  "reports.monthlyAverageCountdownDetail": "Dan verschijnen het maandgemiddelde en de ranglijst.",
  "reports.monthlyAverageRule": "Maandgemiddelden en ranglijsten verschijnen zodra een kalendermaand {days, plural, one {# geregistreerde dag} other {# geregistreerde dagen}} heeft.",
  "reports.monthlyHeatingEfficiency": "Maandelijks verwarmingsrendement",
  "reports.monthlyOutdoorReport": "Maandelijks overzicht buitenshuis",
  "reports.monthlyReport": "Maandelijks overzicht",
  "reports.monthlySolarReport": "Maandelijks overzicht zonneschijn",
  "reports.monthlyWindReport": "Maandelijks windoverzicht",
  "reports.monthsOfData": "{months} maanden aan gegevens",
  "reports.numberOfDays": "Aantal dagen",
  "reports.outdoorReport": "Overzicht buitenshuis",
  "reports.overviewSection": "Overzicht",
  "reports.rainfall": "Neerslag",
  "reports.rainyDays": "Natte dagen",
  "reports.recordDailyRain": "Natste dag",
  "reports.recordHigh": "Warmterecord",
  "reports.recordLow": "Kouderecord",
  "reports.recordsAndClimatology": "Records en klimaat",
  "reports.recordsSince": "Records sinds {date}",
  "reports.recordWindGust": "Sterkste windstoot",
  "reports.relativelyWet": "Relatief nat (60% {lessThan} Luchtvochtigheid ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# rapport} other {# rapporten}}",
  "reports.sendEmail": "Verstuur email",
  "reports.summerDays": "Zomerse dagen",
  "reports.tooDry": "Te droog (Luchtvochtigheid ≤ 45%)",
  "reports.tooWet": "Te vochtig (Luchtvochtigheid {greaterThan} 80%)",
  "reports.tropicalNights": "Tropische nachten",
  "reports.unlockPremiumSubtitle": "Inbegrepen bij SmartMixin Premium",
  "reports.unlockPremiumTitle": "Ontgrendel {count, plural, one {# premiumfunctie} other {# premiumfuncties}}",
  "reports.warmestMonthRanking": "Warmste {month} ooit gemeten",
  "reports.waterBalance": "Waterbalans",
  "reports.yearsOfData": "{years} jaar aan gegevens",
  "reports.yearToDateTemperatureComparison": "Temperatuurvergelijking sinds het begin van het jaar",
  "sensors.bgtSensors": "Zwarte bol & WBGT",
  "sensors.cameraFeed": "Camera",
  "sensors.compareHumidity": "Luchtvochtigheid vergelijken",
  "sensors.compareMoisture": "Bodemvocht vergelijken",
  "sensors.comparePm25": "PM2.5 vergelijken",
  "sensors.compareTemperatures": "Temperaturen vergelijken",
  "sensors.compareWaterTension": "Bodemwaterspanning vergelijken",
  "sensors.depthByChannel": "Diepte per kanaal",
  "sensors.heatStressExtreme": "Extreme hittestress",
  "sensors.heatStressModerate": "Matige hittestress",
  "sensors.heatStressNone": "Geen hittestress",
  "sensors.heatStressStrong": "Sterke hittestress",
  "sensors.heatStressVeryStrong": "Zeer sterke hittestress",
  "sensors.indoorClimate": "Binnenklimaat",
  "sensors.indoorCo2Levels": "CO2-niveaus",
  "sensors.indoorTemperatureAndHumidity": "Temperatuur en luchtvochtigheid",
  "sensors.leafWetnessByChannel": "Bladnatheid per kanaal",
  "sensors.lightningSensor": "Bliksem",
  "sensors.moistureByChannel": "Bodemvocht per kanaal",
  "sensors.noDataAvailable": "Geen gegevens beschikbaar",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 per kanaal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Kanaal selecteren",
  "sensors.sensorDetailDescription": "Bekijk historische gegevens en trends voor uw sensorkanalen.",
  "sensors.sensorHistory": "Sensorgeschiedenis",
  "sensors.soilConductivityByChannel": "Geleidbaarheid per kanaal",
  "sensors.soilTemperatureByChannel": "Bodemtemperatuur per kanaal",
  "sensors.strikesToday": "Inslagen vandaag",
  "sensors.temperatureByChannel": "Temperatuur per kanaal",
  "sensors.viewChart": "Grafiek bekijken",
  "sensors.waterTensionByChannel": "Bodemwaterspanning per kanaal",
  "settings.appearance": "Weergave",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Arabisch",
  "settings.bulgarian": "Bulgaars",
  "settings.catalan": "Catalaans",
  "settings.chartGestures": "Gebaren op grafieken",
  "settings.chartGesturesDescription": "Vegen over grafieken verandert de tijdsperiode, knijpen in grafieken verandert de tijdschaal",
  "settings.choiceCount": "{count, plural, one {# beschikbaar} other {# beschikbaar}}",
  "settings.contactUs": "Contact",
  "settings.contactUsDescription": "Hulp krijgen of feedback sturen",
  "settings.croatian": "Kroatisch",
  "settings.czech": "Tsjechisch",
  "settings.dailyDetailByPeriods": "Dagdetails per dagdeel",
  "settings.dailyDetailByPeriodsDescription": "Groepeer de 24 uur in nacht, ochtend, middag en avond — dezelfde indeling die de dagsamenvatting gebruikt.",
  "settings.danish": "Deens",
  "settings.dark": "Donker thema",
  "settings.dataDisplay": "Gegevensweergave",
  "settings.dateAndTime": "Datum en tijd",
  "settings.donateButton": "Doneren",
  "settings.donateDescription": "SmartMixin wordt gemaakt door een klein team. Als u het nuttig vindt, kunt u de ontwikkeling steunen met een eenmalige donatie van een willekeurig bedrag. Het is een gift — het verandert uw abonnement niet en ontgrendelt geen functies.",
  "settings.donateSuccessBody": "Uw donatie helpt om SmartMixin draaiende te houden en te verbeteren. We waarderen het enorm.",
  "settings.donateSuccessTitle": "Bedankt voor uw steun!",
  "settings.donateTitle": "Steun SmartMixin",
  "settings.dragToReorder": "Sleep om te herschikken",
  "settings.dutch": "Nederlands",
  "settings.english": "Engels",
  "settings.french": "Frans",
  "settings.german": "Duits",
  "settings.gestures": "Gebaren",
  "settings.greek": "Grieks",
  "settings.hungarian": "Hongaars",
  "settings.italian": "Italiaans",
  "settings.japanese": "Japans",
  "settings.korean": "Koreaans",
  "settings.language": "Taal",
  "settings.languageDescription": "Voorkeurstaal",
  "settings.light": "Licht thema",
  "settings.measurementUnits": "Meeteenheden",
  "settings.netatmoDashboard": "Netatmo-dashboard",
  "settings.netatmoLayoutCards": "Kaartenlijst",
  "settings.netatmoLayoutCardsDescription": "Eén kaart per module, alles in één scroll",
  "settings.netatmoLayoutClassic": "Klassiek",
  "settings.netatmoLayoutClassicDescription": "Twee kaarten, veeg tussen modules",
  "settings.netatmoNewLayoutNotice": "Nieuwe indeling: één kaart per module.",
  "settings.netatmoSwitchBackToClassic": "Terug naar klassiek",
  "settings.netatmoSwitchToLayout": "Overschakelen naar {layout}",
  "settings.norwegian": "Noors",
  "settings.notificationsSection": "Meldingen",
  "settings.ongoingNotificationEnabled": "Permanente melding inschakelen",
  "settings.ongoingNotificationMetrics": "Weergegeven metingen",
  "settings.ongoingNotificationPermissionRequired": "Meldingstoestemming is vereist",
  "settings.ongoingNotificationPreviewHint": "Voorbeeld — schakel de widget in om hem te tonen",
  "settings.ongoingNotificationStatusBar": "Statusbalk",
  "settings.polish": "Pools",
  "settings.portuguese": "Portugees",
  "settings.preferencesSection": "Voorkeuren",
  "settings.privacyPolicy": "Privacybeleid",
  "settings.russian": "Russisch",
  "settings.serbian": "Servisch",
  "settings.settings": "Instellingen",
  "settings.settingsPageTitle": "Instellingen - {page}",
  "settings.slovak": "Slovaaks",
  "settings.smallDecimals": "Kleine decimalen",
  "settings.smallDecimalsDescription": "Decimale cijfers in een kleiner formaat weergeven",
  "settings.spanish": "Spaans",
  "settings.statusBarWidget": "Statusbalk-widget",
  "settings.statusBarWidgetDescription": "Altijd zichtbare weerdata",
  "settings.subscriptionSection": "Abonnement",
  "settings.supportSection": "Ondersteuning",
  "settings.swedish": "Zweeds",
  "settings.systemTheme": "Systeemthema",
  "settings.termsOfService": "Gebruiksvoorwaarden",
  "settings.turkish": "Turks",
  "settings.ukrainian": "Oekraïens",
  "settings.units": "Eenheden",
  "settings.unitsDescription": "Maateenheden weergegeven in de applicatie",
  "settings.update": "Bijwerken",
  "settings.windDirectionConvention": "Windrichtingpijl",
  "settings.windDirectionConventionDescription": "Kies hoe windrichtingpijlen worden weergegeven",
  "settings.windDirectionMeteorological": "Oorsprongsrichting",
  "settings.windDirectionMeteorologicalDescription": "Pijl wijst waar de wind vandaan komt (meteorologische conventie)",
  "settings.windDirectionOceanographic": "Stromingsrichting",
  "settings.windDirectionOceanographicDescription": "Pijl wijst waar de wind naartoe waait (oceanografische conventie)",
  "stations.addAStation": "Voeg een station toe",
  "stations.addToFavorites": "Toevoegen aan favorieten",
  "stations.addYourOwnStation": "Voeg uw eigen station toe",
  "stations.clearRecentLocations": "Alles wissen",
  "stations.clearSearch": "Zoekopdracht wissen",
  "stations.currentLocation": "Huidige locatie",
  "stations.customizedStationName": "Aangepaste stationsnaam",
  "stations.favoriteLocations": "Favorieten",
  "stations.favoriteLocationsEmpty": "U kunt maximaal 5 favoriete locaties toevoegen.",
  "stations.favoriteStations": "Favoriete stations",
  "stations.filterStationDescription": "Verberg stations met onbetrouwbare metingen",
  "stations.filterStations": "Filter stations",
  "stations.filterStationSourceDescription": "Selecteer stationsaanbieders die u op de kaart wilt weergeven",
  "stations.findStationsNearYou": "Vind stations bij u in de buurt",
  "stations.hiddenStations": "Verborgen stations",
  "stations.hiddenStationsDescription": "U kunt een station weer zichtbaar maken door ernaast op het oogpictogram te tikken.",
  "stations.lastSeen": "laatst gezien {time}",
  "stations.location": "Locatie",
  "stations.locationAddedToFavorites": "Locatie toegevoegd aan favorieten",
  "stations.locationNotGranted": "Locatietoestemming is niet verleend. Sta toegang tot uw locatie toe in de apparaatinstellingen.",
  "stations.locationRemovedFromFavorites": "Locatie verwijderd uit favorieten",
  "stations.locations": "Locaties",
  "stations.locationUnavailable": "Uw locatie kan niet worden bepaald. Controleer de instellingen van uw apparaat.",
  "stations.maxFavoriteLocationsReached": "U kunt maximaal 5 favoriete locaties hebben. Verwijder er een om een andere toe te voegen.",
  "stations.modifyFavoriteStations": "Favoriete stations wijzigen",
  "stations.modifyFavoriteStationsDescription": "U kunt uw favoriete stations opnieuw ordenen door ze te slepen. U kunt ze ook uit de lijst verwijderen.",
  "stations.myLocation": "Mijn locatie",
  "stations.nearbyWeatherStations": "Nabijgelegen weerstations",
  "stations.noLocationsFound": "Geen locaties gevonden",
  "stations.noSearchResults": "Geen artikelen gevonden voor uw zoekopdracht",
  "stations.noStationsFound": "Geen stations gevonden",
  "stations.noWeatherStationYet": "Er is geen weerstation aanwezig.",
  "stations.recentLocations": "Recent",
  "stations.recentLocationsEmpty": "Uw recente geschiedenis is leeg.",
  "stations.removeFromFavorites": "Verwijder uit favorieten",
  "stations.searchForLocation": "Zoek een locatie",
  "stations.searchForWeatherStation": "Zoek een weerstation",
  "stations.searchResults": "Zoekresultaten",
  "stations.searchResultsEmpty": "Geen resultaten gevonden.",
  "stations.searchResultsFound": "{count, plural, one {# resultaat gevonden} other {# resultaten gevonden}}",
  "stations.searchStationsDescription": "Voer een stad, adres of plaatsnaam in om weerstations in de buurt te vinden.",
  "stations.searchStationsHint": "Gebruik de zoekbalk hierboven om weerstations op elke locatie ter wereld te ontdekken.",
  "stations.selectStationForComparison": "Kies een station om mee te vergelijken",
  "stations.stationAddedToFavorites": "Station toegevoegd aan favorieten",
  "stations.stationCount": "{count, plural, one {# station} other {# stations}}",
  "stations.stationInformation": "Stationsinformatie",
  "stations.stationName": "Stationsnaam",
  "stations.stationObservationsDescription": "Toon de laatste waarnemingen van weerstations",
  "stations.stationRemovedFromFavorites": "Station verwijderd uit favorieten",
  "stations.stationsNear": "Stations in de buurt van {place}",
  "stations.stationType": "Type station",
  "stations.statusOffline": "Offline",
  "stations.statusOnline": "Online",
  "stations.statusStale": "Verouderd",
  "stations.tryAnotherLocation": "We konden geen weerstations vinden in de buurt van deze locatie. Probeer te zoeken in een ander gebied.",
  "stations.weatherStation": "Weerstation",
  "stations.weatherStationCount": "{count, plural, one {# weerstation} other {# weerstations}}",
  "stations.weatherStations": "Weerstations",
  "stations.welcomeConnectService": "Hebt u een weerstation? Koppel uw dienst",
  "stations.welcomeSubtitle": "Uw weer, alles op één plek",
  "thermostat.away": "Weg",
  "thermostat.boilerOn": "Boiler aan",
  "thermostat.hg": "Vorstbeveiliging",
  "thermostat.homeInformation": "Informatie over de woning",
  "thermostat.homeName": "Naam van de woning",
  "thermostat.manualBoost": "Handmatige boost",
  "thermostat.manualSetpointUntil": "Handmatig instelpunt tot",
  "thermostat.noThermostatYet": "Er is nog geen thermostaat aanwezig.",
  "thermostat.relay": "Relais",
  "thermostat.room": "Kamer",
  "thermostat.rooms": "Kamers",
  "thermostat.smartThermostat": "Smart Thermostaat",
  "thermostat.smartValve": "Smart Valve",
  "thermostat.whenBackHome": "Wanneer bent u weer thuis?",
  "units.celsius": "Celsius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Inch",
  "units.inchOfMercury": "Inch kwik",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Kilometer per uur",
  "units.knot": "Knoop",
  "units.meterPerSecond": "Meter per seconde",
  "units.milePerHour": "Mijl per uur",
  "units.millibar": "Millibar",
  "units.millimeter": "Millimeter",
  "units.millimeterOfMercury": "Millimeter kwik",
  "weatherConditions.blizzard": "Sneeuwstorm",
  "weatherConditions.blowingDust": "Opwaaiend stof",
  "weatherConditions.blowingSnow": "Opwaaiende sneeuw",
  "weatherConditions.breezy": "Licht winderig",
  "weatherConditions.clear": "Helder",
  "weatherConditions.cloudy": "Bewolkt",
  "weatherConditions.drizzle": "Motregen",
  "weatherConditions.flurries": "Lichte sneeuwval",
  "weatherConditions.foggy": "Mist",
  "weatherConditions.freezingDrizzle": "Onderkoelde motregen",
  "weatherConditions.freezingRain": "Onderkoelde regen",
  "weatherConditions.frigid": "IJzige kou",
  "weatherConditions.hail": "Hagel",
  "weatherConditions.haze": "Heiigheid",
  "weatherConditions.heavyRain": "Zware regen",
  "weatherConditions.heavySnow": "Zware sneeuwval",
  "weatherConditions.hot": "Hitte",
  "weatherConditions.hurricane": "Orkaan",
  "weatherConditions.isolatedThunderstorms": "Lokale onweersbuien",
  "weatherConditions.mixedRainAndHail": "Regen en hagel",
  "weatherConditions.mostlyClear": "Overwegend helder",
  "weatherConditions.mostlyCloudy": "Overwegend bewolkt",
  "weatherConditions.mostlySunny": "Overwegend zonnig",
  "weatherConditions.notAvailable": "Weersomstandigheden niet beschikbaar",
  "weatherConditions.partlyCloudy": "Gedeeltelijk bewolkt",
  "weatherConditions.rain": "Regen",
  "weatherConditions.rainSleet": "Regen en ijskorrels",
  "weatherConditions.rainSnow": "Regen en sneeuw",
  "weatherConditions.scatteredShowers": "Verspreide buien",
  "weatherConditions.scatteredSnowShowers": "Verspreide sneeuwbuien",
  "weatherConditions.scatteredThunderstorms": "Verspreide onweersbuien",
  "weatherConditions.showers": "Buien",
  "weatherConditions.sleet": "IJskorrels",
  "weatherConditions.smoke": "Rook",
  "weatherConditions.snow": "Sneeuw",
  "weatherConditions.snowShowers": "Sneeuwbuien",
  "weatherConditions.strongStorms": "Zware onweersbuien",
  "weatherConditions.sunny": "Zonnig",
  "weatherConditions.thunderstorms": "Onweersbuien",
  "weatherConditions.tornado": "Tornado",
  "weatherConditions.tropicalStorm": "Tropische storm",
  "weatherConditions.windy": "Winderig",
  "weatherConditions.wintryMix": "Winterse neerslag",
  "weatherMap.legendHeavy": "Zwaar",
  "weatherMap.legendLight": "Licht",
  "weatherMap.legendLightningHelp": "De kleur toont de leeftijd van elke blikseminslag in de afgelopen {minutes} minuten — de nieuwste in wit, de oudste in donkerrood.",
  "weatherMap.legendNewest": "Nieuwste",
  "weatherMap.legendOldest": "Oudste",
  "weatherMap.legendStationsHelp": "De kleur van de markering geeft de waarde van de geselecteerde meting weer.",
  "weatherMap.lightningDataAttribution": "Bliksemgegevens: Blitzortung.org",
  "weatherMap.lightningStrikes": "Blikseminslagen",
  "weatherMap.lightningStrikesDescription": "Toon blikseminslagen in realtime op de kaart",
  "weatherMap.mapLayers": "Kaartlagen",
  "weatherMap.mapLegend": "Kaartlegenda",
  "weatherMap.radarDataAttribution": "Radargegevens: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.rainRadar": "Buienradar",
  "weatherMap.rainRadarDescription": "Geef de regenradar-overlay op de kaart weer",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain is een extra gegevensbron die wordt geleverd via het Tempest Weather System, mogelijk gemaakt door Nearcast Technology. NC Rain-gegevens zijn een schatting van de gemiddelde neerslagaccumulatie rond uw Tempest op buurtniveau",
  "weatherMap.weatherMap": "Weerkaart",
  "weatherMap.weatherMapMetaDescription": "SmartMixin biedt interactieve weer- en radarkaarten voor weersomstandigheden wereldwijd.",
  "weatherWarnings.activeNow": "Nu actief",
  "weatherWarnings.agencyMessage": "Bericht van de weerdienst",
  "weatherWarnings.areaCovered": "Betrokken gebied",
  "weatherWarnings.areaThisLocation": "{area} (deze locatie)",
  "weatherWarnings.areaYourStation": "{area} (uw weerstation)",
  "weatherWarnings.crumb": "Officiële waarschuwingen",
  "weatherWarnings.emptyBody": "De nationale weerdienst heeft voor deze plaats geen waarschuwing van kracht. We controleren het om de paar minuten opnieuw.",
  "weatherWarnings.emptyTitle": "Geen officiële waarschuwingen",
  "weatherWarnings.ended": "Beëindigd",
  "weatherWarnings.endedAt": "Deze waarschuwing is {time} beëindigd.",
  "weatherWarnings.errorBody": "Controleer uw verbinding. We proberen het om de paar minuten opnieuw.",
  "weatherWarnings.errorTitle": "Officiële waarschuwingen konden niet worden geladen",
  "weatherWarnings.fromTime": "Vanaf {time}",
  "weatherWarnings.hazardAirQuality": "Luchtkwaliteit",
  "weatherWarnings.hazardAvalanche": "Lawines",
  "weatherWarnings.hazardCoastalEvent": "Kustgevaren",
  "weatherWarnings.hazardFlood": "Overstromingen",
  "weatherWarnings.hazardFog": "Mist",
  "weatherWarnings.hazardForestFire": "Bosbranden",
  "weatherWarnings.hazardHighTemperature": "Hoge temperaturen",
  "weatherWarnings.hazardLowTemperature": "Lage temperaturen",
  "weatherWarnings.hazardOther": "Ander gevaar",
  "weatherWarnings.hazardRain": "Regen",
  "weatherWarnings.hazardSnowIce": "Sneeuw en ijzel",
  "weatherWarnings.hazardThunderstorm": "Onweersbuien",
  "weatherWarnings.hazardUv": "Uv-straling",
  "weatherWarnings.hazardWind": "Wind",
  "weatherWarnings.hideHazards": "Gevaren verbergen",
  "weatherWarnings.issuedBy": "Uitgegeven door {sender}",
  "weatherWarnings.lastUpdate": "Laatste update: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Kaart van het betrokken gebied: {area}.} other {Kaart van de # betrokken gebieden. {area} is gemarkeerd.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Kaart niet beschikbaar. Het gebied staat hieronder.} other {Kaart niet beschikbaar. De # gebieden staan hieronder.}}",
  "weatherWarnings.moreHazards": "+ nog {count}: {hazards}",
  "weatherWarnings.notInLanguage": "Niet beschikbaar in het {language}. Getoond zoals de weerdienst het heeft gepubliceerd.",
  "weatherWarnings.openOn": "Openen op {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ # ander gebied} other {+ # andere gebieden}}",
  "weatherWarnings.severityExtreme": "Extreem",
  "weatherWarnings.severityFrom": "{severity} vanaf {time}",
  "weatherWarnings.severityMinor": "Licht",
  "weatherWarnings.severityModerate": "Matig",
  "weatherWarnings.severityNow": "{severity} nu",
  "weatherWarnings.severitySevere": "Ernstig",
  "weatherWarnings.severityUntil": "{severity} tot {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {# gebied tonen} other {Alle # gebieden tonen}}",
  "weatherWarnings.showHazards": "Gevaren tonen",
  "weatherWarnings.showPeriods": "{count, plural, one {# periode tonen} other {Alle # periodes tonen}}",
  "weatherWarnings.source": "Bron: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, daarna {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# officiële weerswaarschuwing} other {# officiële weerswaarschuwingen}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Officiële weerswaarschuwingen",
  "weatherWarnings.todayAt": "vandaag om {time}",
  "weatherWarnings.tomorrow": "Morgen",
  "weatherWarnings.tomorrowAt": "morgen om {time}",
  "weatherWarnings.upcoming": "Komend",
  "weatherWarnings.viewAll": "Alle officiële waarschuwingen",
  "weatherWarnings.whatToDo": "Wat te doen"
}
